const Constant = {
    USER_NOT_CONFIRMED_EXCEPTION: 'UserNotConfirmedException',
    USER_SIGNED_IN: 'signedIn',
    NOT_AUTHORIZED_EXCEPTION: 'NotAuthorizedException',
    USER_NOT_FOUND_EXCEPTION: 'UserNotFoundException',
    SIGNED_IN: 'signedIn',
    CONFIRM_SIGN_UP: 'confirmSignUp',
    LOGIN_FAILED_MSG: 'Login failed.',
    ERROR_OCCURRED_MSG: 'エラーが発生しました。',
    AUTH_MODE_API_KEY: 'API_KEY',

    ADMIN: { ON: 1, OFF: 0 },

    TAB_FORM_MANAGEMENT: { FORM: 'form', FIELD: 'field' },

    PROJECT_PERMISSION: {
        BASE: 0,
        MEMBER: 1,
        MANAGER: 2
    },

    FORM_FIELD_MANAGEMENT_ACTION_FLAG: {
        CREATE_NEW_FORM: 'CREATE_NEW_FORM',
        EDIT_FORM: 'EDIT_FORM',
        DELETE_FORM: 'DELETE_FORM',
        UPDATE_FIELD_LIST: 'UPDATE_FIELD_LIST',
        UPDATE_LIST_FIELD_MANAGEMENT: 'UPDATE_LIST_FIELD_MANAGEMENT',
        DELETE_TAG_ITEM: 'DELETE_TAG_ITEM',
        VALIDATE_DUPLICATE_TAG_ITEM: 'VALIDATE_DUPLICATE_TAG_ITEM',
    },

    USAGE_TYPE: {
        CORPORATION: 1,
        USER: 2,
        TICKET: 3,
        PROJECT: 4,
        THREAD_CHAT: 5,
        POST_DETAIL: 6
    },

    PERMISSION_TYPE: {
        USER: 0,
        ADMIN: 1
    },
    //shareRange : Internal
    POST_PUBLIC_FLAG: {
        PUBLIC: 1,
        INTERNAL: 0
    },

    SERVER_ERROR: 'SYSMSG001',
    CHANGE_MANAGER_LAST_ERROR: 'USER01MSG009',
    DATA_CHANGED_PLEASE_RELOAD_ERROR: 'COMMSG030',
    DATA_CHANGED_PLEASE_RELOAD_ERROR_MSG_CODE: 'DATA_CHANGED_PLEASE_RELOAD_ERROR',
    EXISTS_B2B_CUSTOMER_ERROR: 'USER04MSG031',
    ADD_USER_MAX_GENERAL_USER_ERROR: 'USER14MSG011',
    CREATE_TICKET_MAX_GENERAL_ERROR: 'USER14MSG022',
    SUB_DOMAIN_DUPLICATION: 'COMM01MSG04',
    MAX_GENERAL_ID_ERROR: 'USER03MSG007',
    MSG_CM_DELETED_TICKET: 'MSG-CM-DELETED-TICKET',
    MSG_CM_SUBDOMAIN_DATA_DUPLICATION: 'MSG-CM-SUBDOMAIN-DATA-DUPLICATION',
    MSG_CM_EMAIL_DATA_DUPLICATION: 'MSG-CM-EMAIL-DATA-DUPLICATION',
    MSG_SD_DUPLICATED_SCRIPT_TITLE: 'MSG-SD-DUPLICATED-SCRIPT-TITLE',
    MSG_APP_NAME_DUPLICATED: 'MSG-APP-NAME-DUPLICATED',
    MSG_SD_RESTORE_DUPLICATED_TITLE_SCRIPT: 'MSG-SD-RESTORE-DUPLICATED-TITLE-SCRIPT',
    MSG_SD_RESTORE_DUPLICATED_APP_NAME: 'MSG-SD-RESTORE-DUPLICATED-APP-NAME',
    CALL_ALREADY_IN_PROGRESS: 'CALL_ALREADY_IN_PROGRESS',

    CONTROLLABLE_ERROR_TYPE: ['CognitoError', 'UnauthorizedError', 'ApiError'],

    LIMIT_VALUE_SETTING: {
        MAX_NUM_OF_TICKET: 99999999,
        MAX_NUM_OF_STORAGE: 9999.999
    },

    LIMIT_VALUE_ERROR: {
        MAX_NUM_OF_GENERAL_USER: 'USER14MSG010'
    },

    LIMIT_VALUE_NAME: {
        MAX_NUM_OF_GENERAL_USER: 'maxNumOfGeneralUser',
        MAX_NUM_OF_GUEST_USER: 'maxNumOfGuestUser',
        MAX_NUM_OF_CUSTOMER: 'maxNumOfCustomer',
        MAX_NUM_OF_GENERAL_PROJECT: 'maxNumOfGeneralProject',
        MAX_NUM_OF_GUEST_PROJECT: 'maxNumOfGuestProject',
        MAX_NUM_OF_GUEST_DESK: 'maxNumOfGuestDesk',
        MAX_NUM_OF_TICKET: 'maxNumOfTicket',
        MAX_NUM_OF_STORAGE: 'maxNumOfStorage'
    },

    DAYS_HARD_DELETE_TICKET: 30,

    BLANK_IMAGE: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
    // AVATAR_DEFAULT: '/assets/image/imgUser.png',
    AVATAR_DEFAULT: '/assets/image/icon-user-default.svg',
    CHATBOT_DEFAULT: '/assets/image/chatbot.svg',
    USER_PROFILE_AVATAR_DEFAULT: '/assets/image/avatarUser.png',
    LOGO_FILE_NAME_DEFAULT: 'accela_logo.png',
    LOGO_DEFAULT: '/assets/image/accela-technology.png',
    PROJECT_ICON_DEFAULT: '/assets/image/project-icon.png',

    LOGIN_ROUTER: '/login',
    LOGIN_ROUTER_INTERNAL_PARTNER: '/login/:orgCode/p/:orgInvitation',
    LOGIN_ROUTER_INTERNAL_SUPPORTED: '/login/:orgCode/c/:orgInvitation',

    CREATE_ORGANIZATION_ROUTER: '/solutiondesk/organization/create',
    CREATE_ORGANIZATION_SUCCESS_ROUTER: '/solutiondesk/organization/success',
    CONFIRM_CREATE_ORGANIZATION_ROUTER: '/solutiondesk/organization/confirm/',
    LIST_TICKET_ROUTER: '/',
    APPROVE_SUCCESS_ROUTER: '/guest-project/approve',
    REJECT_SUCCESS_ROUTER: '/guest-project/reject',
    PUBLIC_KNOWLEDGE_LIST_ROUTER: '/:subDomain/:projectId/kb',
    PUBLIC_KNOWLEDGE_DETAIL_ROUTER: '/:subDomain/:projectId/kb/:id',
    SHARE_TICKET_ROUTER: '/share/:subDomain/:projectId/ticket/:id',
    SHORT_LINK_TICKET_ROUTER: '/share/:subDomain/:type/:shortKey',

    CREATE_GUEST_CONTRACT_ROUTER: '/guest-contract/create/',
    CONFIRM_CREATE_GUEST_CONTRACT_ROUTER: '/guest-contract/success',

    USER_MANAGEMENT_ROUTER: '/system/userManagement',
    PROJECT_USER_MANAGEMENT_ROUTER: '/project/user-management',
    UPDATE_ORG_PROFILE_ROUTER: '/system/organization-profile',
    PROJECT_MANAGEMENT_ROUTER: '/system/project-management',
    USER_PROFILE_ROUTER: '/user',
    APPROVE_PAGE_ROUTER: '/guest-contract/approve/',
    FORM_MANAGEMENT_ROUTER: '/form/formManagement',
    IFRAME_LOGIN_ROUTER: '/iframe/login',
    FORGOT_PASSWORD_ROUTER: '/forgot-password',
    CONFIRM_FORGOT_PASSWORD: '/confirm-forgot-password',
    IP_REFUSE_PAGE_ROUTER: '/solutiondesk/ip-refuse',

    PROJECT_BASE_NAME: 'ベースプロジェクト',
    PROJECT_GUEST_CUSTOMER_NAME: 'ゲストカスタマープロジェクト',
    TICKET_DUMMY_CUSTOMER_VALUE: 'dummy_customer',

    SHARE_OPTION: {
        INTERNAL_ORG: 1,
        SPECIFIC_ORG: 2,
        B2B_CUSTOMER_ORG: 3,
        B2B_HELPDESK_ORG: 4,
        ALL_ORG: 5
    },

    CORPORATION_ACTIVE: {
        WAITING_APPROVE: 0,
        ACTIVE: 1,
        REJECT: 2,
        BLOCK: 3,
        DELETED: 4
    },

    USER_TYPE: {
        // GENERAL: 1,
        // GUEST: 2,
        // INTERNAL: 3,
        // GUEST_CORP: 4,
        GENERAL: 'GENERAL',
        // GUEST: 'GUEST',
        CUSTOMER: 'BTOC',
        INTERNAL: 'INTERNAL'
    },

    GUEST_USER_FLAG: {
        TRUE: 1,
        FALSE: 0
    },

    PROJECT_TYPE: {
        // GUEST: 1,
        // GENERAL: 2,
        // BASE: 3,
        // GUEST_CORP: 4,
        // GUEST_DESK: 5
        GENERAL: 'PRJ_GENERAL',
        // PRIVATEDESK: 'PRJ_PRIVATEDESK',
        // PUBLICDESK: 'PRJ_PUBLICDESK',
        BASE: 'PRJ_BASE',
        // CUSTOMER: 'PRJ_CUSTOMER',
        CUSTOMER: 'PRJ_BTOC',
        // GUEST: 'PRJ_GUEST',
        // GUESTDESK: 'PRJ_GUESTDESK',

        USER_INFO: 'USER_INFO',
        USER_CUSTOMER: 'USER_CUSTOMER',
        PRJ_BUSINESS_CUSTOMER: 'PRJ_BUSINESS_CUSTOMER',
        PROJECT_CHATBOT_CATEGORIES: 'PRJ_CHATBOT_CATEGORIES'
    },

    // Note: name display for detail ticket, list ticket, create delegate ticket
    PROJECT_BASE_DISPLAY_NAME: '組織内個人問い合わせ',

    INVITE_PROJECT_TYPE: {
        GUEST: 'PRJ_GUEST',
        GUESTDESK: 'PRJ_GUESTDESK'
    },

    DESK: { ON: 1, OFF: 0 },

    PUBLIC: { ON: 1, OFF: 0 },

    PROJECT_SERVICE_TYPE: {
        DESK_OFF: '一般プロジェクト',
        DESK_ON_PUBLIC_OFF: '組織内サービスデスクプロジェクト',
        DESK_ON_PUBLIC_ON: '公開サービスデスクプロジェクト'
    },

    DEFAULT_LIMIT: 999999,
    ITEMS_PER_QUERY_LIMIT: 300,

    THREAD_TYPE: {
        CUSTOMER: 1,
        INTERNAL: 2,
        ESCALATION: 3,
        DELEGATE: 4,
        AI_ASSISTANT: 5
    },
    EVENT_EMITTER_TYPE: {
        GET_TICKET_LIST: 'GET_TICKET_LIST',
        GET_TICKET_LIST_WITH_CHANGE_PROJECT: 'get_ticket_list_with_change_project',
        GET_TICKET_LIST_WITH_CHANGE_MENU: 'get_ticket_list_with_change_menu',
        GET_TICKET_LIST_WITH_ADD_TICKET: 'get_ticket_list_with_add_ticket',
        GET_LIST_USER_IN_PROJECT: 'get_list_user_in_project'
    },

    TYPE_GET_TICKET_LIST: {
        CUSTOMER: 'customer',
        HELPDESK: 'helpdesk'
    },

    MENU_SELECT_TYPE: {
        TICKET_LIST_CUSTOMER_SIDE: 'customer',
        TICKET_LIST_HELP_DESK_SIDE: 'helpdesk',
        SYSTEM: 'system',
        USER_PROFILE: 'user_profile',
        PROJECT_SETTING: 'project_setting'
    },

    POST_TYPE: {
        MSG: 'msg',
        IMAGE: 'image',
        FILE: 'file',
        MSG_FILES: 'msg_files',
        MSG_VOICE: 'msg_voice',
        END_LIVE_CHAT_MESSAGE: 'end_live_chat_message',
        SYSTEM_AUTO_END_LIVE_CHAT: 'system_auto_end_live_chat',
        SUPPORT_MSG: 'support-msg', // Live chat with agent,
        CHAT_BOT_CONNECTED_WITH_AGENT: 'chat_bot_connected_with_agent',
        CHAT_BOT_NOT_FOUND_AGENT: 'chat_bot_not_found_agent',
        ANONYMOUS_END_LIVE_CHAT: 'ANONYMOUS_END_LIVE_CHAT',
        TICKET_REMOVED: 'TICKET_REMOVED',
        TWILIO_CALL_EVENT: 'twilio-call-event'
    },

    ACTION_CHANGE_LIST_DATA_TYPE: {
        INITIAL: 1,
        ADD: 2,
        PUSH: 3,
        REPLACE: 4,
        CONCAT: 5
    },

    COLOR_THREAD_CHAT: {
        CUSTOMER_TAB: '#2E3138',
        INTERNAL_TAB: '#3161B1',
        ESCALATE_TAB: '#A37E29',
        REFERENCE_TAB: '#68C1E7',
        AI_ASSISTANT_TAB: '#299773',

        CUSTOMER_CHAT: '#CECFD1',
        INTERNAL_CHAT: '#A4C5FF',
        ESCALATE_CHAT: '#FEE8B6',
        REFERENCE_CHAT: '#E3F6FE',
        AI_ASSISTANT_CHAT: '#E8E5F7'
    },

    THREAD_CHAT_TYPE: {
        CUSTOMER_THREAD: 1,
        INTERNAL_THREAD: 2,
        ESCALATION_THREAD: 3,
        KNOWLEDGE_THREAD: 4,
        ANONYMOUS_SUPPORT_THREAD: 5
    },

    TICKET_TYPE: {
        QA: 1,
        DELEGATE: 2,
        NOTICE: 3,
        ESCALATION: 4,
        INVITATION_GUEST_PROJECT: 5,
        INVITATION_GUEST_DESK_PROJECT: 6,

        APPROVE: 7,

        INTERNAL_QA: 8,
        EXTERNAL_QA: 9,
        REQUEST_EXTERNAL_DESK: 10,
        APPROVE_GUEST_PROJECT: 11,
        APPROVE_GUEST_DESK_PROJECT: 12,
        BROADCAST_PARENT: 13,
        BROADCAST_CHILD: 14,

        INVITATION_GUEST_CUSTOMER: 15,
        KNOWLEDGE: 16,
        TASK: 17,
        MASTER_KNOWLEDGE: 18,
        REQUEST_EXTERNAL_CUSTOMER: 19,
        PDF_FILE_KNOWLEDGE: 20,
        PDF_PAGE_KNOWLEDGE: 21,
        EMAIL: 22,
        EMAIL_REPLY: 23,
        TELEPHONE: 24,
    },

    HELPDESK_CREATE_TICKET_TYPE: {
        NOTICE: 1,
        DELEGATE: 2,
        INVITATION_GUEST: 3,
        TASK: 4,
        EMAIL: 5
    },

    TICKET_INVITATION_GUEST: "TICKET_INVITATION_GUEST",

    QA_CREATE_TICKET_TYPE: {
        QA: 1,
        INVITATION: 2
    },

    LIVE_OR_ARCHIVED: {
        // DRAFT: 'DRAFT',
        LIVE: 'LIVE',
        ARCHIVED: 'ARCHIVED'
    },

    TICKET_PUBLIC: {
        DRAFT: 'DRAFT',
        PUBLIC: 'PUBLIC',
        PRIVATE: 'PRIVATE'
    },

    CHAT_POST_STATUS: {
        UN_READ: 1,
        READ: 2,
        DELETE_READ: 4,
        DELETE: 5
    },

    ANONYMOUS_CHATBOT_ACTION: {
        DELETE_MSG: 'DELETE_MSG',
        CREATE_MSG: 'CREATE_MSG',
        CREATE_THUMBNAIL: 'CREATE_THUMBNAIL'
    },

    ANONYMOUS_TYPE: {
        CHATBOT: 'CHATBOT',
        IFRAME: 'IFRAME',
        CHATBOT_LIVECHAT: 'CHATBOT_LIVECHAT'
    },

    SYS_FIELD: {
        ATTACHMENTS: 'attachments',
        OUTLINE: 'outline',
        PERSON_IN_CHARGE: 'personInCharge',
        FROM: 'from',
        TO: 'to',
        CC: 'cc',
        BCC: 'bcc',
        MAIL_SUBJECT: 'mailSubject',
        MAIL_BODY: 'mailBody',
        TICKET_TYPE: 'ticketType',
        PROXIED_USER: 'proxiedUser',
        DEADLINE: 'deadline',
        LIST_OF_SYNONYMS: 'listOfSynonyms',
        TICKET_ID: 'ticketId',
        BODY: 'body',
        FIELD_QA_CATEGORY: 'field_qa_category',
        SDAUTO_SCRIPT: 'sdauto_script',
        SDAUTO_PARAMS_DESCRIPTION: 'sdauto_params_description',
        BUSINESS_APP_NAME: 'field_business_app_name'
    },

    CORPORATION_CONTRACT: {
        TYPE: {
            TRIAL: 1,
            STANDARD: 2,
            PREMIUM: 3,
            GUEST: 4
        },
        DATA: {
            DEFAULT_EXPIRE_TIME: 365 * 24 * 60 * 60 * 1000,
            TRIAL_EXPIRE_TIME: 30 * 24 * 60 * 60 * 1000,
            DEFAULT_NUM_OF_AGENT: 0,
            DEFAULT_MAX_AGENT: 20,
            DEFAULT_NUM_OF_GUEST_DESK_PROJECT: 0,
            DEFAULT_MAX_NUM_OF_GUEST_DESK_PROJECT: 0,
            DEFAULT_NUM_OF_GENERAL_USER: 0,
            DEFAULT_MAX_GENERAL_USER: 20,
            DEFAULT_NUM_OF_TICKET: 0,
            DEFAULT_MAX_NUM_OF_TICKET: 20 * 20000, // Max general user * 20000
            DEFAULT_NUM_OF_STORAGE: 0,
            DEFAULT_MAX_NUM_OF_STORAGE: 20 * 5 * 1024 * 1024 * 1024, // Max general user * 5 GB (Unit is B)
            DEFAULT_NUM_OF_GENERAL_PROJECT: 0,
            DEFAULT_MAX_OF_GENERAL_PROJECT: 0,
            DEFAULT_NUM_OF_PROJECT_PUBLIC_ON: 0,
            DEFAULT_MAX_OF_PROJECT_PUBLIC_ON: 0,
            DEFAULT_NUM_OF_PROJECT_DESK_ON: 0,
            DEFAULT_MAX_OF_PROJECT_DESK_ON: 0
        }
    },

    SECRET_KEY_ENCRYPT_INVITATION_DATA: 'Omi2021',
    SECRET_KEY_ENCRYPT_GENERATE_DATA: 'Omi2022',

    INVITATION_FLAG: {
        INPROCESS: 0, // default
        WAITING_APPROVE: 1,
        INVITE_SUCCESS: 2,
        INVITE_REJECTED: 3,
        INVITE_DELETED: 4
    },

    APPROVE_FLAG: {
        INPROCESS: 0,
        APPROVE: 1,
        REJECTED: 2
    },

    CLOUD_FRONT_URL_DEV: 'https://d1ltmpvqq83o9p.cloudfront.net',
    S3_FILE_TYPE: {
        TICKET_FILE: 1,
        CHAT_POST_FILE: 2,
        USER_PROFILE_FILE: 3,
        CORPORATION_LOGO_LOGIN_FILE: 4,
        CORPORATION_LOGO_PROFILE_FILE: 5
    },
    S3_URL_EXPIRY_TIME: 1,
    S3_URL_AES_ENCODE_KEY: 'accelaBaDesk',
    PASSWORD_AES_ENCODE_KEY: 'accelaBaDesk',
    SUBSCRIPTION_TYPE: {
        CREATE: 'create',
        UPDATE: 'update',
        DELETE: 'delete'
    },

    PANEL_TYPE: {
        LIST_TICKET: 'list_ticket',
        CHAT_THREAD: 'chat_thread',
        DETAIL_TICKET: 'detail_ticket',
        ADD_TICKET: 'add_ticket',
        DETAIL_TICKET_APPROVE: 'detail_ticket_approve',

        FORM_MANAGEMENT: 'form_management',
        LIST_TICKET_KNOWLEDGE: 'list_ticket_knowledge',

        HELPDESK_TICKET_LIST: 'helpdesk_ticket_list',
        HELPDESK_CHATTHREAD: 'helpdesk_chatThread',
        HELPDESK_TICKET_DETAIL: 'helpdesk_ticket_detail',
        HELPDESK_TICKET_LIST_DRILLDOWN_AND_DETAIL_SEARCH:
            'helpdesk_ticket_list_drilldown_and_detail_search',

        CUSTOMER_TICKET_LIST: 'customer_ticket_list',
        CUSTOMER_CHATTHREAD: 'customer_chatThread',
        CUSTOMER_TICKET_DETAIL: 'customer_ticket_detail',

        KNOWLEDGE_TICKET_LIST: 'knowledge_ticket_list',
        KNOWLEDGE_HELPDESK_TICKET_LIST: 'knowledge_helpdesk_ticket_list',
        KNOWLEDGE_CHATTHREAD: 'knowledge_chatThread',
        KNOWLEDGE_TICKET_DETAIL: 'knowledge_ticket_detail',
        KNOWLEDGE_HELPDESK_TICKET_DETAIL: 'knowledge_helpdesk_ticket_detail',
        KNOWLEDGE_CREATE_TICKET: 'knowledge_create_ticket',
        KNOWLEDGE_HELPDESK_DRILLDOWN_AND_DETAIL_SEARCH:
            'knowledge_helpdesk_drilldown_and_detail_search',
        KNOWLEDGE_PRJ_INUSE_DRILLDOWN_AND_DETAIL_SEARCH:
            'knowledge_prj_inuse_drilldown_and_detail_search',
        KNOWLEDGE_UPLOAD_CSV: 'knowledge_upload_csv',

        SYSTEM_MANAGEMENT: 'system_management',
        SYSTEM_USER_MANAGEMENT: 'system_user_management',
        SYSTEM_USER_PROFILE: 'system_user_profile',
        SYSTEM_PROJECT_MANAGEMENT: 'system_project_management',
        SYSTEM_PROJECT_PROFILE_MANAGEMENT: 'system_project_profile_management',
        SYSTEM_PROJECT_USER_MANAGEMENT: 'system_project_user_management',
        SYSTEM_PROJECT_CUSTOMER_MANAGEMENT: 'system_project_customer_management',
        SYSTEM_CORPORATION_CUSTOMER_MANAGEMENT: 'system_corporation_customer_management',
        SYSTEM_PROJECT_SETTING_IFRAME: 'system_project_setting_iframe',
        SYSTEM_PUBLIC_KNOWLEDGE_SITE_SETTING: 'system_public_knowledge_site_setting',
        SYSTEM_PROJECT_SETTING_CHATBOT: 'system_project_setting_chatbot',
        SYSTEM_PROJECT_SETTING_AI: 'system_project_setting_ai',
        SYSTEM_NORMAL_CONTRACT_DETAIL: 'system_normal_contract_detail',

        PROJECT_MANAGEMENT: 'project_management',
        ORGANIZATION_MANAGEMENT: 'organization_management',
        FORMAT_MANAGEMENT: 'format_management',
        PERSONAL_MANAGEMENT: 'personal_management',

        SYSTEM_ORG_PROFILE: 'system_org_profile',
        SYSTEM_FIELD_MANAGEMENT: 'system_field_management',
        LIST_NOTIFICATION: 'list_notification',
        ROOT_LIST_ORG: 'root_list_org',
        ROOT_ORG_EDIT_CONTRACT: 'root_edit_org_contract',
        QA_CATEGORY_SETTING: 'qa_category_setting',
        PREVIEW_CHATBOT: 'preview_chatbot',
        PRODUCT_MANAGEMENT: 'product_management',
        VERSION_MANAGEMENT: 'version_management',
        OPEN_CHAT_AI: 'open_chat_ai',
        MCP_SERVER_SETTING: 'MCP_SERVER_SETTING',
        PANEL_MANAGEMENT: 'PANEL_MANAGEMENT',
        BUSINESS_APP_DETAIL: 'BUSINESS_APP_DETAIL',
    },

    TAB_PANEL_TYPE: {
        QA_NEW_TICKET_TAB: 'QA_NEW_TICKET_TAB',
        HELPDESK_NEW_TICKET: 'HELPDESK_NEW_TICKET',
        SYSTEM_USER_PROFILE: 'system_user_profile',
        SYSTEM_ORG_PROFILE: 'system_org_profile',
        SYSTEM_PROJECT_MANAGEMENT: 'system_project_management',
        SYSTEM_USER_MANAGEMENT: 'system_user_management',
        SYSTEM_FIELD_MANAGEMENT: 'system_field_management',
        SYSTEM_PROJECT_USER_MANAGEMENT: 'system_project_user_management',
        SYSTEM_PROJECT_PROFILE_MANAGEMENT: 'system_project_profile_management',
        SYSTEM_PROJECT_CUSTOMER_MANAGEMENT: 'system_project_customer_management',
        SYSTEM_CORPORATION_CUSTOMER_MANAGEMENT: 'system_corporation_customer_management',
        KNOWLEDGE_CREATE_TICKET: 'knowledge_create_ticket',
        KNOWLEDGE_TICKET_DETAIL: 'knowledge_ticket_detail',
        KNOWLEDGE_TICKET_DETAIL_CLOSE_TAB: 'knowledge',
        ROOT_ORG_INFO: 'ROOT_ORG_INFO',
        ROOT_ORG_EDIT_ORG_INFO: 'ROOT_ORG_EDIT_ORG_INFO',
        SYSTEM_PUBLIC_KNOWLEDGE_SITE_SETTING: 'system_public_knowledge_site_setting',
        SYSTEM_PROJECT_SETTING_CHATBOT: 'system_project_setting_chatbot',
        SYSTEM_PROJECT_SETTING_AI: 'system_project_setting_ai',
        SYSTEM_NORMAL_CONTRACT_DETAIL: 'system_normal_contract_detail',
        QA_CATEGORY_SETTING: 'qa_category_setting',
        NEW_TAB_CHAT_AI: 'new_tab_chat_ai',
        TAB_DUPLICATE_TICKET: 'Duplicate_ticket_',
        CUSTOMER_TICKET_LIST_TAB: 'customer_ticket_list_tab',
        EXTERNAL_API_SETTING: 'EXTERNAL_API_SETTING',
        MCP_SERVER_SETTING: 'MCP_SERVER_SETTING',
        PANEL_MANAGEMENT: 'PANEL_MANAGEMENT',
        BUSINESS_APP_DETAIL: 'BUSINESS_APP_DETAIL',
    },

    // User mngユーザー管理, user profileユーザプロフィール, Proj mngプロジェクト管理,プロジェクトのユーザー管理、
    // org profile組織プロフィール,  Field Form Mngフォーマット編集、

    // ・[Helpdesk Ticket list]
    // ・[Helpdesk Ticket detail]
    // ・[Helpdesk ChatThread]
    // ・[QA Ticket list]
    // ・[QA Ticket detail]
    // ・[QA ChatThread]
    // ・[Knowledge list]
    // ・[Knowledge ChatThread]
    // ・[Knowledge detail]
    // ・[Edit Field]
    // ・[Edit Format]
    // ・[Quản lý User]
    // ・[Quản lý Project]
    // ・[Edit User Profile]

    SCREEN_LIST: {
        B2C_IN_ORG: 'B2C_IN_ORG',
        B2C_IN_PROJECT: 'B2C_IN_PROJECT',
        KNOWLEDGE_DETAIL: 'KNOWLEDGE_DETAIL',
        KNOWLEDGE_CREATE_AND_DRAFT: 'KNOWLEDGE_CREATE_AND_DRAFT',
    },

    APPROVE_PAGE_ACTION_TYPE: {
        REJECT: 'reject',
        APPROVE: 'approve'
    },

    // usage {ORG|PRJ|USER}
    SYSTEM_USAGE_TYPE: {
        CORPORATION: 1,
        PROJECT: 2,
        USER: 3,
        THREAD: 4,
        TICKET: 5,
        STORAGE: 6
    },

    ACTIVE_FLAG: {
        ACTIVE: 1,
        INACTIVE: 0,
        DELETED: 2,
        REJECT: 3,
        NOT_INVITED: 4
    },

    USERMANAGEMENT_ACTION_FLAG: {
        DELETE_USER_IN_ORG: 'delete',
        RESTORE: 'restore',
        CREATE_AND_UPDATE_USER_IN_CORP: 'CREATE_AND_UPDATE_USER_IN_CORP',
        ADD_AND_EDIT_USER_IN_PROJECT: 'ADD_AND_EDIT_USER_IN_PROJECT',
        DELETE_USER_IN_PROJECT: 'DELETE_USER_IN_PROJECT',
        DELETE_B2C_CUSTOMER_IN_CORPORATION: 'DELETE_B2C_CUSTOMER_IN_CORPORATION',
        ACTIVE_USER_AFTER_FIRST_LOGIN: 'ACTIVE_USER_AFTER_FIRST_LOGIN',
        ACTIVING_MFA: 'ACTIVING_MFA'

    },

    CUSTOMERMANAGEMENT_ACTION_FLAG: {
        CREATE_AND_UPDATE_CUTOMER_IN_CORP: 'CREATE_AND_UPDATE_CUTOMER_IN_CORP'
    },

    AUTO_TRANSLATION_FLAG: {
        TRUE: 1,
        FALSE: 0
    },

    PRIVILEGE_PROJECT: {
        PRJ_MGR: 'PRJ_MGR'
    },

    PRIVILEGE_USER: {
        ADMIN: 'ADMIN',
        OWNER: 'OWNER',
        ADMIN_OWNER: 'ADMIN_OWNER'
    },

    AGENT_FLAG: {
        TRUE: 1,
        FALSE: 0
    },

    ADMIN_MODE: {
        ON: 'ON',
        OFF: 'OFF'
    },

    ROOT_FLAG: {
        TRUE: 1,
        FALSE: 0
    },

    STATUS_SERVICE_PERMISSION: {
        ON: 1,
        OFF: 0
    },

    CORPORATION_CONTRACT_TYPE: {
        ROOT: 'ROOT',
        GUEST: 'GUEST',
        GUEST_DESK: 'GUESTDESK',
        TRIAL: 'TRIAL',
        STANDARD: 'STANDARD',
        PREMIUM: 'PREMIUM',
        TEMPLATE_GUEST: 'TEMPLATE_GUEST',
        TEMPLATE_TRIAL: 'TEMPLATE_TRIAL',
        TEMPLATE_STANDARD: 'TEMPLATE_STANDARD',
        TEMPLATE_PREMIUM: 'TEMPLATE_PREMIUM'
    },

    LANGUAGE_TYPE: {
        JP: 'jp',
        EN: 'en'
    },

    ERROR_CHANGE_USER_ADMIN_WITH_INTERNAL: 'Internalユーザーはアドミン権限を持つことが出来ません。',

    TICKET_USAGE: {
        REQ: 'REQ',
        TASK: 'TASK',
        KNOWLEDGE: 'KNOWLEDGE'
    },

    FORM_USAGE: {
        FORM: 'FORM',
        FIELD: 'FIELD',
        TAG: 'TAG',
        STATUS: 'STATUS',
        SPRINT: 'SPRINT',
        FORM_GLOBAL: 'FORM_GLOBAL',
        FIELD_GLOBAL: 'FIELD_GLOBAL',
        CORP_SHARED_FORM_FIELD: 'CORP_SHARED_FORM_FIELD',
        FORM_USING_TICKET: 'FORM_USING_TICKET'
    },

    FORM_TYPE: {
        FORM_REQ: 'REQ',
        FORM_REQ_QA: 'REQ_QA',
        FORM_REQ_NOTICE: 'REQ_NOTICE',
        FORM_REQ_INVITE_GUEST: 'REQ_INVITE_GUEST',
        FORM_REQ_INVITE_GUESTDESK: 'REQ_INVITE_GUESTDESK',
        FORM_REQ_EXTERNAL_DESK: 'REQ_EXTERNAL_DESK',
        FORM_REQ_INVITE_GUEST_CUSTOMER: 'REQ_INVITE_GUEST_CUSTOMER',
        FORM_REQ_EXTERNAL_CUSTOMER: 'REQ_EXTERNAL_CUSTOMER',
        FILE_FORMAT: 'FILE_FORMAT',
        PAGE_FORMAT: 'PAGE_FORMAT',
        EMAIL_FORMAT: 'EMAIL_FORMAT',
        TELEPHONE_FORMAT: 'TELEPHONE_FORMAT', // fake. In db: type = REQ_QA.

        FORM_TASK: 'TASK',
        FORM_KNOWLEDGE: 'KNOWLEDGE',
        FORM_MASTER: 'MASTER',

        FIELD_TEXT: 'TEXT',
        FIELD_KEYWORD: 'KEYWORD',
        FIELD_INT: 'INT',
        FIELD_FLOAT: 'FLOAT',
        FIELD_RICHTEXT: 'RICHTEXT',
        FIELD_URL: 'URL',
        FIELD_DATE: 'DATE',
        FIELD_TIME: 'TIME',
        FIELD_DATE_TIME: 'DATE_TIME',
        FIELD_TAG: 'TAG',
        FIELD_WORKFLOW: 'WORKFLOW',
        FIELD_IFRAME: 'IFRAME',
        MERMAID: 'MERMAID',
        HTML: 'HTML',
        MARKDOWN: 'MARKDOWN',
    },

    STATUS_NO: {
        WAITING: 1,
        TODO: 2,
        DOING: 3,
        DONE: 4,
        PENDING: 5
    },

    FILTER_LIST_FORM_TYPE: {
        FORM_REQ_QA: 'REQ_QA',
        FORM_REQ_NOTICE: 'REQ_NOTICE',
        FORM_TASK: 'TASK',
        FORM_KNOWLEDGE: 'KNOWLEDGE',
        FORM_MASTER: 'MASTER',
        FORM_SYSTEM: 'SYSTEM'
    },

    FORM_DEFINITION: {
        SYSTEM: 'SYSTEM',
        SAMPLE: 'SAMPLE',
        USER: 'USER',
        MASTER: 'MASTER',
        SYSTEM_MASTER_FIELD: 'SYSTEM_MASTER_FIELD'
    },

    FORM_DEFINITION_NAME: {
        SYSTEM: 'システム',
        SAMPLE: 'SysAdmin'
    },

    FORM_VIEW_FOR_CUSTOMER: {
        TRUE: 1,
        FALSE: 0
    },

    FIELD_UI: {
        TEXT: 'Text',
        TEXT_AREA: 'TextArea',
        DATE: 'Date',
        NUMBER: 'Number',
        TAG: 'Tag',
        DROP_FILE: 'DropFile',
        IFRAME: 'Iframe',
        URL: 'URL',

        WORKFLOW: 'Status',
        SELECTOR: 'Selector',
        FIELD_RICHTEXT: 'Rich Text',
        TEXT_WITH_CHIP: 'Text With Chip',
        MERMAID: 'Mermaid',
        HTML: 'HTML',
        MARKDOWN: 'Markdown',
    },

    FIELD_UI_SELECT_DEFAULT_ITEM: {
        title: '選択してください',
        value: null,
        isDisplay: true
    },

    SYSTEM_FORM_INVITE_GUEST_NAME: 'サポート対象プロジェクト作成',
    SYSTEM_FORM_INVITE_GUESTDESK_NAME: 'パートナープロジェクト作成',
    SYSTEM_FORM_QA_NAME: '問い合わせ用デフォルトフォーマット ',
    SYSTEM_FORM_EXTERNAL_DESK_REQUEST_NAME: '既存サービスデスクプロジェクトを選ぶ',
    SYSTEM_FORM_GUEST_CUSTOMER_INVITATION_NAME: 'ゲストカスタマー登録',
    SYSTEM_FORM_EXTERNAL_CUSTOMER_REQUEST_NAME: '既存プロジェクトを選ぶ',

    SYSTEM_FORM_NAME: {
        SYSTEM_AI_CHAT_PROMPT: 'AIチャットプロンプト',
        SYSTEM_AI_ASSISTANT_PROMPT: 'AIアシスタントプロンプト',
        SYSTEM_AI_TELEPHONE_PROMPT: 'AI自動応答プロンプト',
        SYSTEM_AI_TRAINING_PROMPT: 'AIトレーニングプロンプト',
        SYSTEM_FORM_SDAUTO: 'SDスクリプト',
        BUSINESS_APP: '業務アプリ',
        TELEPHONE_FORMAT: 'ボイスフォーマット'
    },

    SYSTEM_FORM_ORDER: {
        DEFAULT: 1,
        EMAIL_FORMAT: 0.9,
        SD_AUTO_FORM: 0.895,
        FORM_AI_CHAT_PROMPT: 0.89,
        FORM_AI_AI_AUTO_PERIODIC: 0.88,
        FORM_AI_AI_AUTO_TIMER: 0.87,
        FORM_AI_AI_AUTO_EVENT: 0.86,
        FORM_AI_TELEPHONE_PROMPT: 0.85,
        FORM_AI_ASSISTANT_PROMPT: 0.855,
        FORM_AI_TRAINING_PROMPT: 0.856,
        BUSINESS_APP: 11,
        TELEPHONE_FORMAT: 12,
    },

    FORM_FILE_UPLOAD_LIST_INPUT_NAME: 'fileUploadList',

    FORM_MANAGEMENT_SCREEN: {
        LIST_FORM: 'formList',
        ADD_FORM: 'addForm',
        EDIT_FORM: 'editForm',
        LIST_FIELD: 'fieldList',
        ADD_FIELD_TAG_ITEM: 'addFieldTagItem',
        ADD_FIELD_STATUS_ITEM: 'addFieldStatusItem',
        FIELD_ADD_TO_FORM_REGION: 'listFieldAddToForm',
        FIELD_IN_PROJECT_REGION: 'listFieldInProject'
    },

    CLIENT_FIELD_TYPE: {
        ADD_NEW_FIELD: 'ADD_NEW_FIELD',
        DUPLICATE_FIELD: 'DUPLICATE_FIELD'
    },

    TAG_FIELD_DEFAULT: {
        IS_MULTIPLE: true,
        SELECT_OPTION_TYPE: 'select',
        CHECK_OPTION_TYPE: 'check',
        RECORD_NUMBER: 5,
        IS_ADD_ITEM: true
    },

    TEXT_FIELD_DEFAULT: {
        MIN_LENGTH: 0,
        MAX_LENGTH: 20000,
        INPUT_FORMAT: ''
    },

    HANDLE_EVENT_TYPE: {
        MULTIPLE_ADD_TAG_FIELD: 'MULTIPLE_ADD_TAG_FIELD',
        SELECT_OPTION_ADD_TAG_FIELD: 'SELECT_OPTION_ADD_TAG_FIELD',
        CHECK_OPTION_ADD_TAG_FIELD: 'CHECK_OPTION_ADD_TAG_FIELD',
        RECORD_NUMBER_ADD_TAG_FIELD: 'RECORD_NUMBER_ADD_TAG_FIELD',
        IS_ADD_ITEM_ADD_TAG_FIELD: 'IS_ADD_ITEM_ADD_TAG_FIELD',
        USER_PERMISSION_CREATE_ITEM_TAG: 'USER_PERMISSION_CREATE_ITEM_TAG'
    },

    SETTING_SELECT_ITEM_TAG_FIELD: {
        DEFAULT: '',
        CUSTOMISE: 'customise',
        MASTER_FORMAT_NAME: 'master_format_name',
        MASTER_KNOWLEDGE: 'master_knowledge',
        AUTO_FILL: 'auto_fill',
        SYSTEM_MASTER: 'system_master'
    },

    DISPLAY_ORDER_TAG_FIELD: {
        DEFAULT: '',
        CUSTOMISE: 'customise',
        DICTIONARY_ORDER: 'dictionary_order',
        HITS_NUMBER_ORDER: 'hits_number_order'
    },

    USER_PERMISSION_CREATE_ITEM_TAG: {
        PROJECT_MANAGEMENT: 'project_management',
        PROJECT_MANAGEMENT_AND_AGENT: 'project_management_and_agent',
        PROJECT_MEMEBER: 'project_member',
        ALL_USER_IN_ORG: 'all_user_in_org',
        ALL_USER: 'all_user'
    },

    STATUS_OF_USER: {
        ACTIVE: 'Active',
        WAITING: 'Waiting',
        REJECT: 'Reject',
        DELETED: 'Deleted',
        NOT_INVITED: 'Not Invited'
    },

    UPDATE_TICKET_METHOD: {
        UPDATE_ASSIGNEE: 1,
        UPDATE_STATUS: 2,
        UPDATE_FIELD_TICKET: 3,
        FORCE_EDIT_ASSIGNEE_AND_STATUS: 4,
        UPDATE_DELETED_AT: 5,
        ARCHIVE_TICKET: 6,
        UPDATE_SHARE_STATUS: 7,
        UPDATE_ANONYMOUS_STATUS: 8,
        UPDATE_BACK_TO_DRAFT: 9,
        BACK_TO_ARRIVAL: 10,
        UPDATE_FOOTPRINT: 11,
        UPDATE_FOOTPRINT_FILE_AND_PAGE_KNOWLEDGE: 12,
        DELIVER_REPLY_EMAIL_TICKET: 13,
        DELIVER_UNSENT_MESSAGE: 14,
        RESTORE_SDSCRIPT_DUPLICATE_TITLE: 15,
    },

    UPDATE_CORP_DETAIL_METHOD: {
        UPDATE_DETAIL: 1,
        DESK_SERVICE: 2,
        KNOWLEDGE: 3,
        TASK: 4,
        PUBLIC_SERVICE: 5,
        UPDATE_BASIC_INFO: 6,
        CHAT_AI: 7,
        UPDATE_VIEW_CONTRACT_DETAILS: 8
    },

    CREATE_TICKET_METHOD: {
        CREATE_TICKET: 'CREATE_TICKET',
        CREATE_ATTACHMENT: 'CREATE_ATTACHMENT'
    },

    TIME_TO_LIVE_REQUEST_CREATE_USER: 7 * 24 * 60 * 60 * 1000, // 7 days,
    // TIME_TO_LIVE_REQUEST_CREATE_USER: 5 * 60 * 1000, // 5 min

    CREATE_CONTRACT_EXPIRED_AFTER: 72 * 60 * 60 * 1000, // 3 days
    // CREATE_CONTRACT_EXPIRED_AFTER : 10 * 60 * 1000, // 10 min

    SETTING_FORM_DEFAULT: {
        REQUIRED: false,
        DO_NOT_SHOW: 1,
        READ_ONLY: 2,
        PUBLIC_FOR_CUSTOMER: 3
    },
    TAG_FIELD_OPTION_TYPE: {
        SELECT: 'select',
        CHECKBOX: 'checkBox',
        RADIO: 'radio'
    },

    SETTING_DATE_FIELD_FORMAT: {
        YYYYMMDD_HHMM: 'yyyymmdd_hhmm',
        YYYYMMDD: 'yyyymmdd',
        YYYYMM: 'yyyymm',
        YYYY: 'yyyy',
        HHMM: 'hhmm',
        YYYYMMDD_HHMMSS: 'yyyymmdd_hhmmss',
        HHMMSS: 'hhmmss'
    },

    MOMENT_DATE_FORMAT: {
        YYYYMMDD_HHMM: 'YYYY/MM/DD HH:mm',
        YYYYMMDD_HHMMSS: 'YYYY/MM/DD HH:mm:ss',
        YYYYMMDD: 'YYYY/MM/DD',
        YYYYMM: 'YYYY/MM',
        YYYY: 'YYYY',
        HHMM: 'HH:mm',
        HHMMSS: 'HH:mm:ss'
    },

    VIEW_DATE_PICKER: {
        YEAR: 'year',
        MONTH: 'month'
    },

    ICON_CLOSE_DATETIME: '/assets/image/icon-close-datetime.svg',

    COMPONENT_DATETIME_PICKER: {
        DATE_TIME_PICKER: 'date_time_picker',
        DATE_PICKER: 'date_picker',
        TIME_PICKER: 'time_picker'
    },

    LIST_TICKET_TAB: {
        INTERNAL_QA: 'INTERNAL_QA',
        EXTERNAL_QA: 'EXTERNAL_QA',
        CUSTOM_SUPPORT: 'CUSTOM_SUPPORT'
    },

    EXTERNAL_REQUEST_TYPE: {
        DESK_REQUEST: 'DESK_REQUEST'
    },

    NUMBER_FIELD_DEFAULT: {
        UNIT: '',
        UNIT_POSITION_AFTER: 'after',
        UNIT_POSITION_BEFORE: 'before',
        MIN_VALUE: -2000000000,
        MAX_VALUE: 2000000000,
        INTEGER_ONLY: false
    },

    NA: 'NA',

    TICKET_TYPE_FORM_STATUS: {
        ACTIVE: true,
        INACTIVE: false
    },

    URL_REGEX: /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/+#-]*[\w@?^=%&/+#-])?/,
    REGEX_FTP: /^ftp:\/\/(?:[a-zA-Z0-9_-]+(?::[a-zA-Z0-9_-]+)?@)?(?:[a-zA-Z0-9.-]+|\[[0-9a-fA-F:.]+\])(?::\d{1,5})?(?:\/[^\s]*)?$/,
    REGEX_FILE: /file:\/\/\/?[A-Za-z]+/,
    REGEX_NOTES: /(Notes|notes):\/\/[^\s]+/,
    PROTOCOL: {
        HTTP: 'http',
        HTTPS: 'https',
        FTP: 'ftp',
        FILE: 'file',
        NOTES: 'notes'
    },

    FIELD_USING_FORMS: {
        ACTIVE: true,
        INACTIVE: false,
        HAS_VALUE: true,
        NO_VALUE: false
    },
    KNOWLEDGE_PUBLIC_TYPE: {
        INTERNAL: 'INTERNAL',
        EXTERNAL: 'EXTERNAL'
    },
    KNOWLEDGE_PUBLIC_RANGE: {
        ONLY_ME: 'ONLY_ME',
        PROJECT_ONLY: 'PROJECT_ONLY',
        CORPORATION_ONLY: 'CORPORATION_ONLY',
        ALL: 'ALL'
    },

    KNOWLEDGE_VIEW_EDIT_PERMISSION: {
        CREATOR_ONLY: 'CREATOR_ONLY',
        IN_PROJECT: 'IN_PROJECT',
        IN_ORG: 'IN_ORG',
        B2B_CUSTOMER: 'B2B_CUSTOMER',
        B2B_SUPPORT: 'B2B_SUPPORT',
        PUBLIC: 'PUBLIC',
        PROJECT_MANAGER: 'PROJECT_MANAGER',
        CREATOR: 'CREATOR'
    },

    KNOWLEDGE_CHAT_PERMISSION: {
        NO: 'NO',
        IN_PROJECT: 'IN_PROJECT',
        IN_ORG: 'IN_ORG',
        PUBLIC: 'PUBLIC',
        BY_VIEW_PERMISSION: 'BY_VIEW_PERMISSION'
    },

    KNOWLEDGE_ADDITIONAL_PERMISSION_TEMPLATE: {
        orgProject: [],
        guestCustomerProject: [],
        baseProject: [],
        b2bCustomerProject: [],
        b2bHelpdeskProject: []
    },

    KNOWLEDGE_RANGE: {
        PUBLIC: 'PUBLIC'
    },

    NOTIFICATION_SYSTEM_TYPE: {
        SDESK: 'sDesk'
    },

    NOTIFICATION_OBJECT_TYPE: {
        QA: 'QA',
        ORG: 'Org',
        PROJECT: 'Project',
        REQUEST_EXTERNAL_DESK: 'REQUEST_EXTERNAL_DESK',
        NOTICE: 'Notice',
        KNOWLEDGE: 'KNOWLEDGE',
        DELEGATE: 'DELEGATE',
        REQUEST_EXTERNAL_CUSTOMER: 'REQUEST_EXTERNAL_CUSTOMER',
        INVITATION_GUEST_PROJECT: 'INVITATION_GUEST_PROJECT',
        INVITATION_GUEST_DESK_PROJECT: 'INVITATION_GUEST_DESK_PROJECT',
        TASK: 'TASK',
        EMAIL: 'EMAIL',
        TELEPHONE: 'TELEPHONE',
    },

    NOTIFICATION_EVENT_TYPE: {
        TICKET_NEW: 'TICKET_NEW',
        TICKET_UPDATE: 'TICKET_UPDATE',
        UPDATE_PIC: 'UPDATE_PIC',
        ADMIN_ON: 'ADMIN_ON',
        ADMIN_OFF: 'ADMIN_OFF',
        AGENT_ON: 'AGENT_ON',
        AGENT_OFF: 'AGENT_OFF',
        MEMBER_ON: 'MEMBER_ON',
        MEMBER_OFF: 'MEMBER_OFF',
        PM_ON: 'PM_ON',
        PM_OFF: 'PM_OFF',
        MESSAGE_NEW: 'MESSAGE_NEW',
        USER_TYPE_CHANGE: 'USER_TYPE_CHANGE',
        MESSAGE_ATTACHMENT_NEW: 'MESSAGE_ATTACHMENT_NEW',
        MESSAGE_MENTION_TO: 'MESSAGE_MENTION_TO',
        EXCEED_MAX_TICKET: 'EXCEED_MAX_TICKET',
        EXCEED_MAX_GENERAL_USER_WHEN_CREATE_TICKET: 'EXCEED_MAX_GENERAL_USER_WHEN_CREATE_TICKET',
        DELETE_PROJECT: 'DELETE_PROJECT',
        KNOWLEDGE_CHAT_MESSAGE_NEW: 'KNOWLEDGE_CHAT_MESSAGE_NEW',
        MENTION_IN_CHAT_KNOWLEDGE: 'MENTION_IN_CHAT_KNOWLEDGE',
        //Contract
        NOTI_UPDATE_CONTRACT_CREDIT_CARD: 'NOTI_UPDATE_CONTRACT_CREDIT_CARD',
        NOTI_UPDATE_CONTRACT_BANK_TRANSFER: 'NOTI_UPDATE_CONTRACT_BANK_TRANSFER',
        OVER_MAX_RESOURCES: 'OVER_MAX_RESOURCES',

        // Register org
        NOTI_ORG_REGISTERED_TRIAL: 'NOTI_ORG_REGISTERED_TRIAL',
        NOTI_ORG_STARTED_TRIAL: 'NOTI_ORG_STARTED_TRIAL',
        NOTI_YOURS_CONTRACT_HAVE_BEEN_UPDATED: 'NOTI-YOURS-CONTRACT-HAVE-BEEN-UPDATED'
    },

    TYPE_GET_NOTIFICATION_LIST: {
        ALL: 'ALL',
        UNREAD: 'UNREAD'
    },
    NOTIFICATION_SOURCE_OBJECT: {
        TICKET: 'TICKET',
        CHATPOST: 'CHATPOST',
        USER: 'USER'
    },
    NOTIFICATION_REMOVE_AFTER: 7 * 24 * 60 * 60 * 1000, // 7 days,

    VISIBILITY_SETTING_TYPE: {
        CUSTOMER: 'CUSTOMER',
        CUSTOMER_IN_ORG: 'CUSTOMER_IN_ORG',
        CUSTOMER_OUT_ORG: 'CUSTOMER_OUT_ORG',
        PRIVATE: 'PRIVATE',
        PROJECT: 'PROJECT',
        CUSTOM: 'CUSTOM',
        IN_ORG: "IN_ORG"
    },

    VISIBILITY_SETTING_LABEL: {
        PRIVATE: 'プライベート',
        PROJECT: 'プロジェクト',
    },

    CUSTOMER_TYPE: {
        CUSTOMER_IN_ORG: 'CUSTOMER_IN_ORG',
        CUSTOMER_OUT_ORG: 'CUSTOMER_OUT_ORG'
    },

    VIEW_NAME_DEFAULT: 'ビュー',

    STATUS_VIEW: {
        SHOW: 'SHOW',
        HIDDEN: 'HIDDEN'
    },

    VIEW_TYPE: {
        CUSTOM: 'CUSTOM',
        DEFAULT: 'DEFAULT'
    },

    DEFINITION_VIEW: {
        KNOWLEDGE: 'KNOWLEDGE',
        HELPDESK: 'HELPDESK'
    },

    EDIT_VIEW_NAME_ERROR_TYPE: {
        BLANK: 'BLANK',
        DUPLICATE: 'DUPLICATE',
        MAX_LENGTH: 'MAX_LENGTH'
    },

    MAX_LENGTH: {
        VIEW_NAME: 30,
        FORM_NAME: 50,
        FIELD_NAME: 50
    },

    ACTION_LIST_FORM: {
        ADD_NEW_FORM: 'ADD_NEW_FORM',
        EDIT_FORM: 'EDIT_FORM',
        DUPLICATE_FORM: 'DUPLICATE_FORM'
    },

    KNOWLEDGE_SEARCH_SCREEN: {
        DRILLDOWN: 'drilldown',
        SEARCH_OPTION: 'search_option'
    },

    KNOWLEDGE_SEARCH_OPTION: {},

    SETTING_SEARCH_KEYWORD: {
        AND: 'and',
        OR: 'or',
        MUTIPLE: 'mutiple',
        COMMENT: 'comment',
        SIMILAR: 'similar',
        K_NN: 'k.NN'
    },

    VIEW_DEFAULT: {
        NEW_ARRIVAL: '新着ナレッジ'
    },

    DRILLDOWN_SEARCH_OPTION_SORT_TYPE: {
        CREATED_AT: 'CREATED_AT',
        UPDATED_AT: 'UPDATED_AT',
        LATEST_COMMENT: 'LATEST_COMMENT',
        MOST_COMMENT: 'MOST_COMMENT',
        MOST_SEEN_LATER: 'MOST_SEEN_LATER',
        MOST_FOOTPRINT: 'MOST_FOOTPRINT',
        TITLE_ASC: 'TITLE_ASC',
        TITLE_DESC: 'TITLE_DESC',
        KEYWORD_MATCH: 'KEYWORD_MATCH',
        DOC_BODY_ASC: 'DOC_BODY_ASC',
        DOC_BODY_DESC: 'DOC_BODY_DESC',
        SIMILAR: 'SIMILAR',
        PAGE_NO: 'PAGE_NO',
        SORT_TOTAL_PRIVATE_BOOKMARK_ASC: 'SORT_TOTAL_PRIVATE_BOOKMARK_ASC',
        SORT_TOTAL_PRIVATE_BOOKMARK_DESC: 'SORT_TOTAL_PRIVATE_BOOKMARK_DESC'
    },

    FORMAT_OPTION_SEARCH: {
        FORM: 'form',
        CREATOR: 'creator',
        UPDATOR: 'updator',
        PROXIED_USER: 'proxiedUser',
        PUBLIC_RANGE: 'publicRange',
        SUFFIX_OF_ATTACHMENTS: 'suffixOfAttachments',
        STATUS_FIELD: 'status',
        TAG_FIELD: 'tag',
        PROJECT_ORIGIN: 'projectOrigin',
        PROJECT_TARGET: 'projectTarget',
        LIVE_OR_ARCHIVED: 'liveOrArchived',
        TICKET_TYPE: 'ticketType',
        TICKET_CREATED_PROJECT_ID: 'ticketCreatedProjectId',
        PRIVATE_BOOKMARK: 'privateBookmark',
        SHARED_BOOKMARK: 'sharedBookmark',
        EMAIL_TICKET_ORIGIN: 'emailTicketOrigin',
        MCP_SERVER_SETTING: 'mcpServerSetting',
        BOOKMARK: 'bookmark',
        SYSTEM_FIELD: 'systemField',
        TAG: 'tag',
        OTHER: 'other',
        PERSON_IN_CHARGE: 'personInCharge',
    },

    DRILLDOWN_USAGE: {
        SYSTEM: 'SYSTEM',
        STATUS: 'STATUS',
        TAG: 'TAG'
    },

    KNOWLEDGE_DATE_SEARCH_OPTION: {
        TYPE: {
            RANGE: 'RANGE',
            AGO: 'AGO'
        },
        AGO_VALUE: 0,
        AGO_UNIT: {
            WEEK: 'WEEK',
            DAY: 'DAY'
        }
    },

    MASTER_FIELD_AUTO_ADD_DATA: {
        ON: true,
        OFF: false
    },

    MASTER_FIELD_AUTO_FILL: {
        ON: true,
        OFF: false
    },

    MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE: {
        USER: 'USER',
        PROJECT: 'PROJECT',
        CORPORATION: 'CORPORATION'
    },

    MASTER_FIELD_SYSTEM_MASTER_CORPORATION_TYPE: {
        INUSE: 'INUSE',
        CUSTOMER: 'CUSTOMER',
        SUPPORT: 'SUPPORT'
    },

    MASTER_FIELD_SYSTEM_MASTER_PROJECT_TYPE: {
        INUSE: 'INUSE',
        ALL: 'ALL'
    },

    MASTER_FIELD_SYSTEM_MASTER_USER_TYPE: {
        ALL: 'ALL',
        GENERAL: 'GENERAL',
        ADMIN: 'ADMIN',
        PROJECT_MANAGER: 'PROJECT_MANAGER',
        AGENT: 'AGENT',
        INTERNAL_CUSTOMER: 'INTERNAL_CUSTOMER',
        B2C_CUSTOMER: 'B2C_CUSTOMER',
        GUEST: 'GUEST'
    },

    RELATED_MASTER_FORM_DEFAULT: 'NULL',

    SETTING_PUBLIC_FOR_CUSTOMER: {
        HIDE: 1,
        ONLY_VIEW: 2,
        EDITABLE: 3
    },

    CREATE_TICKET_DIALOG_CONFIRM_TYPE: {
        HELPDESK: 'HELPDESK',
        FORM: 'FORM'
    },

    CREATE_TICKET_DEFAULT_VALUE: {
        INVITE_GUESTDESK: {
            OUTLINE: '弊社サポート窓口を開設しました。',
            CATEGORY: 'パートナープロジェクト作成',
            DESCRIPTION:
                'ヘルプデスクの開設ありがとうございます。\n本チケットに対してチャットで返信可能です。'
        },
        EXTERNAL_DESK_REQUEST: {
            OUTLINE: 'サポート取引よろしくお願いします。',
            CATEGORY: '取引申請'
        },
        INVITE_GUEST: {
            CATEGORY: 'サポート対象プロジェクト作成',
            DESCRIPTION:
                '登録ありがとうございます。\n本チケットに対してチャットで問い合わせ可能です。\nまた、新規の問い合わせ案件ごとに、「新規問い合わせ」ボタンより新たなチケットを発行し、問い合わせを行うなど各種サポートを受けることができます。'
        },
        INVITE_GUEST_CUSTOMER: {
            OUTLINE: '弊社サポート窓口を開設しました。 ',
            CATEGORY: 'ゲストカスタマー登録',
            DESCRIPTION:
                '登録ありがとうございます。\n本チケットに対してチャットで問い合わせ可能です。\nまた、新規の問い合わせ案件ごとに、「新規問い合わせ」ボタンより新たなチケットを発行し、問い合わせを行うなど各種サポートを受けることができます。 '
        },
        REQUEST_EXTERNAL_CUSTOMER: {
            OUTLINE: 'サポート取引よろしくお願いします。',
            CATEGORY: '取引申請'
        }
    },

    CUSTOMER_SIDE_VIEW: {
        IN_CHARGE_QA_VIEW: 'IN_CHARGE_QA_VIEW',
        DRAFT_QA_VIEW: 'DRAFT_QA_VIEW',
        ARCHIVE_QA_VIEW: 'ARCHIVE_QA_VIEW',
        NOTICE_VIEW: 'NOTICE_VIEW',
        INVITATION_VIEW: 'INVITATION_VIEW',
        TELEPHONE_VIEW: 'TELEPHONE_VIEW'
    },

    QA_FILTER_CREATOR: {
        ME: 'ME',
        PROJECT_MEMBER: 'PROJECT_MEMBER',
        ALL: 'ALL'
    },

    QA_FILTER_STATUS: {
        SENT: 'SENT',
        DRAFT: 'DRAFT',
        ARCHIVE: 'ARCHIVE'
    },

    HELPDESK_LIST_TYPE: {
        INTERNAL: 'INTERNAL',
        EXTERNAL: 'EXTERNAL'
    },

    DEFAULT_VIEW_STRUCTURE: {
        keyword: '',
        fields: [],
        tagFields: [],
        statusFields: [],
        options: {
            method: 'and',
            attribute: 'mutiple',
            from: null,
            to: null,
            searchDateType: 'RANGE',
            searchDateAgoValue: 0,
            searchDateAgoUnit: 'DAY',
            otherFields: {
                include: [],
                exclude: []
            }
        },
        visibility: 'PRIVATE'
    },

    TICKET_DATA_TYPE: {
        TICKET: 'TICKET',
        FIELD: 'FIELD'
    },

    TICKET_PROPERTY: {
        SENT: 'SENT',
        DRAFT: 'DRAFT',
        ARCHIVE: 'ARCHIVE',
        DELETE: 'DELETE',
        SYNONYM: 'SYNONYM',
        TRAINING: 'TRAINING' // View for training/learning tickets in HelpDesk
    },

    TICKET_DATA_ID: {
        OUTLINE: 'outline',
        DESCRIPTION: 'description',
        MEMO: 'memo',
        ATTACHMENT: 'attachment',
        SUFFIX_OF_ATTACHMENTS: 'suffixOfAttachments',
        KNOWLEDGE_CANVAS: 'knowledgeCanvas',
        ENQUETE: 'enquete',
        ENQUETECOMMENT: 'enqueteComment',
        CUSTOMER_NOTICE: 'customerNotice',
        TICKET_ID: 'ticketId'
    },

    GSI: {
        CHAT_THREAD_ID_AND_CREATED_AT_INDEX: 'ChatThreadIdAndCreatedAtIndex',
        TICKET_ID_AND_CREATED_AT_INDEX: 'TicketIdAndCreatedAtIndex',
        ORGANIZATION_DOMAIN_INDEX: 'OrganizationDomainIndex',
        FORM_GSI_1: 'FormGSI1',
        FORM_GSI_2: 'FormGSI2',
        NOTIFICATION_GSI_1: 'NotificationGSI1',
        PROJECT_GSI_1: 'ProjectGSI1',
        PROJECT_GSI_2: 'ProjectGSI2',
        PROJECT_GSI_3: 'ProjectGSI3',
        TICKET_GSI_1: 'TicketGSI1',
        TICKET_GSI_2: 'TicketGSI2',
        TICKET_GSI_3: 'TicketGSI3',
        CORPORATION_ID_INDEX: 'CorporationIdIndex',
        USER_EMAIL_INDEX: 'UserEmailIndex',
        VIEW_GSI_1: 'ViewGSI1',
        QUEUE_GSI_1: 'QueueGSI1',
        SCAN: 'SCAN',
        BOOKMARK_GSI_2: 'BookmarkGSI2',
        BOOKMARK_GSI_3: 'BookmarkGSI3',
        USER_BOOKMARK_GSI_1: 'UserBookmarkGSI1',
        USER_BOOKMARK_GSI_2: 'UserBookmarkGSI2',
        USER_BOOKMARK_GSI_3: 'UserBookmarkGSI3',
    },

    ANONYMOUS_QA_PAGE: {
        CREATE_ANONYMOUS_QA: 'CREATE_ANONYMOUS_QA',
        CONFIRM_ANONYMOUS_QA: 'CONFIRM_ANONYMOUS_QA',
        SEND_ANONYMOUS_QA_SUCCESS: 'SEND_ANONYMOUS_QA_SUCCESS'
    },
    ANONYMOUS_USER_ID: 'anonymous',
    ANONYMOUS_TICKET_STATUS: {
        INPROGRESS: 0,
        WAITING_APPROVE: 1,
        APPROVE: 2,
        REJECTED: 3,
        CHAT_NOW: 4,
        END_LIVE_CHAT: 5,
        END_LIVE_CHAT_AGENT_NOT_RESPONSE: 6,
        END_LIVE_CHAT_CASE_TICKET_WAITING: 7,
        INPROGRESS_CREATE_TICKET: 8 // Creating ticket(crawling data when create ticket by csv,....)
    },

    TICKET_LIST_PAGINATION_DEFAULT_RECORD: 20,
    DELETE_TICKET_AFTER_TIME: 30,

    CHAT_MENTION_ALL: {
        id: 'ALL',
        name: 'all',
        mail: 'Everyone in this space',
        avatar: '/assets/image/mention-all.svg'
    },
    CHAT_PAGINATION_DEFAULT_RECORD: 30,
    MAX_EMOJI_PER_CHAT_POST: 20,
    MAX_REACTION_BY_USER: 10,
    MAX_REACTION_TOOLTIP_USERNAME: 5,

    B2B_CUSTOMER_PROJECT_STATUS: {
        ACTIVE: 'Active',
        WAITING: 'Waiting',
        REJECT: 'Reject',
        DELETED: 'Deleted'
    },

    EMAIL_MAX_LENGTH: 128,
    TRIGGER_TIMEOUT_WHEEL_END: 500,
    SCROLL_LEFT_CHANGE: 50,
    SNAP_SCROLL_THRESHOLD: 0.3, // 30% of container width for snap scrolling
    WIDTH_CHECK_DRAG_END: 4,
    LIST_VIEW_TICKET_HELP_DESK: 4,
    LIST_VIEW_TAB: 4,

    NAME_TAG_FIELD_MAX_LENGTH: 5000,

    NOTICE_ALL_CUSTOMER: {
        ALL_CUSTOMER_PROJECT: 'AllCustomerProject',
        ALL_GUEST_CUSTOMER_USER: 'AllGuestCustomerUser',
        ALL_GENERAL_PROJECT: 'AllGeneralProject',
        ALL_USER_IN_BASE_PROJECT: 'AllUserInBaseProject'
    },

    NOTICE_GROUP_CUSTOMER: {
        ALL_CUSTOMER_PROJECT: 'ALL_CUSTOMER_PROJECT',
        ALL_GUEST_CUSTOMER_USER: 'ALL_GUEST_CUSTOMER_USER',
        ALL_GENERAL_PROJECT: 'ALL_GENERAL_PROJECT',
        ALL_USER_IN_BASE_PROJECT: 'ALL_USER_IN_BASE_PROJECT'
    },

    TIME_TO_LIVE_30_DAYS: 2592000000,

    INVITE_GUEST_CONTRACT_EXPIRE_AFTER: 72 * 60 * 60 * 1000, // 72h

    PROJECT_USER_TAB_MANAGEMENT: {
        TAB_USER_PROJECT_LIST: 'userProjectList',
        TAB_B2C_CUSTOMER_MANAGEMENT: 'b2CCustomerManagement',
        TAB_B2B_CUSTOMER_MANAGEMENT: 'b2bCustomerManagement'
    },

    CORPORATION_CUSTOMER_TAB_MANAGEMENT: {
        TAB_CUSTOMER_LIST_CORPORATION: 'TAB_CUSTOMER_LIST_CORPORATION'
    },

    NO_PROJECT: {
        VALUE: 'NO_PROJECT',
        DISPLAY: '未登録プロジェクト'
    },

    NONAME: '無名',
    UPDATOR_SYSTEM: 'System',
    RESTORE_USER_TYPE: {
        USER_IN_ORG: 'USER_IN_ORG',
        B2C_IN_ORG: 'B2C_IN_ORG',
        B2C_IN_PROJECT: 'B2C_IN_PROJECT'
    },

    COGNITO_USER_STATUS: {
        UNCONFIRMED: 'UNCONFIRMED',
        CONFIRMED: 'CONFIRMED',
        ARCHIVED: 'ARCHIVED',
        UNKNOWN: 'UNKNOWN',
        RESET_REQUIRED: 'RESET_REQUIRED',
        FORCE_CHANGE_PASSWORD: 'FORCE_CHANGE_PASSWORD'
    },

    COMPONENT_NAME: {
        DETAIL_TICKET_DRAFT: 'DetailTicketDraft',
        DETAIL_TICKET_KNOWLEDGE: 'DetailTicketKnowledge',
        DETAIL_TICKET_PDF_KNOWLEDGE: 'DetailTicketPdfKnowledge',
        DETAIL_TICKET_EMAIL: 'DetailTicketEmail',
        SETTING_CHAT_BOT: 'SettingChatbot',
        QA_CATEGORY_SETTING: 'QA_CategorySetting',
        PREVIEW_CHATBOT: 'PreviewChatBot',
        TICKET_LIST: 'TicketList',
        ADD_TICKET: 'AddTicket',
        CHAT_THREAD: 'ChatThread',
        CHAT_THREAD_KNOWLEADGE: 'ChatThreadKnowledge',
        DETAIL_TICKET: 'DetailTicket',
        FORM_MANAGEMENT: 'FormManagement',
        USER_MANAGEMENT: 'UserManagement',
        USER_PROFILE: 'UserProfile',
        ORGANIZATION_PROFILE: 'OrganizationProfile',
        PROJECT_MANAGEMENT: 'ProjectManagement',
        PROJECT_PROFILE_MANAGEMENT: 'ProjectProfileManagement',
        PROJECT_USER_MANAGEMENT: 'ProjectUserManagement',
        PROJECT_CUSTOMER_MANAGEMENT: 'ProjectCustomerManagement',
        CORPORATION_CUSTOMER_MANAGEMENT: 'CorporationCustomerManagement',
        LIST_TICKET_KNOWLEDGE: 'ListTicketKnowledge',
        NOTIFICATION_LIST: 'NotificationList',
        DRILLDOWN_AND_DETAIL_SEARCH: 'DrilldownAndDetailSearch',
        PROJECT_SETTING_IFRAME: 'ProjectSettingIframe',
        ROOT_LIST_ORG: 'RootListOrg',
        PUBLIC_KNOWLEDGE_SITE_SETTING: 'PublicKnowledgeSiteSetting',
        KNOWLEDGE_UPLOAD_CSV: 'knowledgeUploadCsv',
        EDIT_ORG_CONTRACT: 'editOrgContract',
        NORMAL_VIEW_CONTRACT_DETAIL: 'NormalViewContractDetail',
        SETTING_AI: 'SettingAI',
        OPEN_CHAT_AI: 'OpenChatAI',
        EXTERNAL_API_SETTING: 'EXTERNAL_API_SETTING',
        MCP_SERVER_SETTING: 'MCP_SERVER_SETTING',
        PANEL_MANAGEMENT: 'PANEL_MANAGEMENT',
        BUSINESS_APP_DETAIL: 'BUSINESS_APP_DETAIL',
    },
    DUMMY_DRILLDOWN_STATUS_ID: 'drilldown_status_field',
    DUMMY_PREFIX_DRILLDOWN_STATUS_ITEM_ID: 'drilldown_status_item_',
    DELETED_USER_NAME: 'Deleted User',
    DELETED_USER_EMAIL_SUFFIX: '_deleted',

    KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT: {
        NO: 'チャットスレッドを設定しない',
        IN_PROJECT: 'プロジェクト内',
        IN_ORG: '組織内',
        PUBLIC: '一般公開',
        BY_VIEW_PERMISSION: 'ナレッジの閲覧権限に追従する'
    },

    KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT: {
        CREATOR_ONLY: '投稿者',
        PROJECT_MANAGER: 'プロジェクトマネージャー',
        IN_PROJECT: 'プロジェクト内',
        IN_ORG: '組織内',
        B2B_CUSTOMER: '全B2Bカスタマープロジェクト',
        B2B_SUPPORT: '全B2Bサポートプロジェクト',
        PUBLIC: 'SolutionDeskのユーザー全員',
        BY_VIEW_PERMISSION: 'ナレッジの閲覧権限に追従する'
    },

    KNOWLEDGE_TICKET_SHARE_STATUS: {
        CREATOR_ONLY: '投稿者',
        IN_PROJECT: 'プロジェクト内',
        IN_ORG: '組織内',
        B2B_CUSTOMER: '全B2Bカスタマープロジェクト',
        B2B_SUPPORT: '全B2Bサポートプロジェクト',
        PUBLIC: '一般公開'
    },

    KNOWLEDGE_TICKET_SHARE_STATUS_DETAIL_SETTING: {
        DETAIL_SETTING: '[詳細設定]'
    },

    KNOWLEDGE_SHARE_STATUS_LABEL: '公開範囲',
    KNOWLEDGE_SHARE_STATUS_LABEL_ADDITIONAL: '詳細設定',

    KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT: {
        CREATOR: '投稿者',
        IN_PROJECT: 'プロジェクト内',
        IN_ORG: '組織内',
        B2B_CUSTOMER: '全B2Bカスタマープロジェクト',
        B2B_SUPPORT: '全B2Bサポートプロジェクト',
        PUBLIC: '一般公開'
    },

    STATUS_OF_ORG: {
        ACTIVE: 'Active',
        WAITING: 'Waiting',
        REJECT: 'Reject',
        BLOCK: 'Block'
    },

    SUFFIX_TEXT: {
        // DELETED_USER: '削除済み',
        DELETED_USER: '削除済みのユーザー',
        BLOCK_CORPORATION: '停止中',
        DELETED_CORPORATION: '削除済み'
    },

    TICKET_DELETED_STATUS: {
        REMOVED: 'REMOVED',
        INUSED: 'INUSED',
        TERM_REMOVED: 'TERM_REMOVED',
        ARCHIVED: 'ARCHIVED'
    },

    DOCUMENT_TITLE: {
        DEFAULT: 'SolutionDesk',
        ORGANIZATION_CREATE: '組織の新規登録 - SolutionDesk',
        ORGANIZATION_SUCCESS: '組織登録成功 - SolutionDesk',
        ORGANIZATION_CONFIRM: '組織登録情報の確認 - SolutionDesk',

        LOGIN: 'ログイン',
        GUEST_CONTRACT_CREATE: 'ゲスト契約の登録 - SolutionDesk',
        GUEST_CONTRACT_APPROVE: 'ゲスト契約でプロジェクト生成依頼の確認 - SolutionDesk',
        GUEST_CONTRACT_SUCCESS: 'ゲスト契約登録成功 - SolutionDesk',

        GUEST_PROJECT_APPROVE: 'ゲスト契約でプロジェクト生成依頼の承認 - SolutionDesk',
        GUEST_PROJECT_REJECT: 'ゲスト契約でプロジェクト生成依頼の却下 - SolutionDesk',
        FORGOT_PASSWORD: 'パスワードの再設定 - SolutionDesk',
        CONFIRM_FORGOT_PASSWORD: 'パスワードの確認 - SolutionDesk',
        IFRAME_LOGIN: 'ログイン',
        IFRAME_ANONYMOUS_QA: '未登録ユーザーの問合せ作成'
    },

    UPDATE_PROJECT_RESOURCE_METHOD: {
        CREATE_NEW_PROJECT: 'CREATE_NEW_PROJECT',
        EDIT_PROJECT: 'EDIT_PROJECT',
        CREATE_AND_EDIT_PROJECT: 'CREATE_AND_EDIT_PROJECT',
        DELETE_PROJECT: 'DELETE_PROJECT',
        DELETE_B2B_CUSTOMER: 'DELETE_B2B_CUSTOMER',
        SETTING_CHATBOT: 'SETTING_CHATBOT',
        SETTING_PUBLIC_KNOWLEDGE_SITE: 'SETTING_PUBLIC_KNOWLEDGE_SITE',
        SETTING_AI: 'SETTING_AI',
        UPDATE_PROJECT_PROFILE: 'UPDATE_PROJECT_PROFILE',
        BASIC_PROMPT_VALIDATE: 'BASIC_PROMPT_VALIDATE',
        UPDATE_MANAGEMENT_PANEL: 'UPDATE_MANAGEMENT_PANEL',
        SAVE_RECENT_OUTBOUND_CALL: 'SAVE_RECENT_OUTBOUND_CALL',
        GET_RECENT_OUTBOUND_CALLS: 'GET_RECENT_OUTBOUND_CALLS',
    },
    ATTACH_FILE_IMAGE_EXTENSIONS: 'tiff,tif,jpeg,jpg,jpe,jfif,jfi,jif,bmp,gif,png',

    ATTACH_FILE: {
        SIZE_SMALL: 'small',
        SIZE_MEDIUM: 'medium',
        VIEW_TICKET: 'ticket',
        VIEW_CHAT: 'chat',
        VIEW_TICKET_DETAIL: 'ticket_detail',
        VIEW_PUBLIC_KNOWLEDGE: 'ticket_public_knowledge',
        ATTACH_BY: {
            CHAT: 'chat',
            TICKET: 'ticket',
            AI_CHAT: 'ai_chat',
        }
    },

    CREATE_THUMBNAIL_ACTION_TYPE: {
        CREATE_THUMBNAIL_FOR_TMP_IMG: 'CREATE_THUMBNAIL_FOR_TMP_IMG',
        CREATE_THUMBNAIL_AFTER_CREATED_ATTACH_FILE: 'CREATE_THUMBNAIL_AFTER_CREATED_ATTACH_FILE',
        CREATE_NEW_THUMBNAIL_AND_ATTACH_FILE: 'CREATE_NEW_THUMBNAIL_AND_ATTACH_FILE' 
    },

    QUEUE_TYPE: {
        USER: {
            AUTO_REJECT: 'AUTO_REJECT'
        },
        THREAD: {
            DELETE_TIME_OUT_SUPPORT_THREAD: 'DELETE_TIME_OUT_SUPPORT_THREAD'
        },
        TICKET: {
            DISABLED_TIMEOUT_CHAT_NOW: 'DISABLED_TIMEOUT_CHAT_NOW'
        },
        STORAGE: {
            UPDATE_STATUS_UPLOAD_CSV: 'UPDATE_STATUS_UPLOAD_CSV'
        }
    },

    QUEUE_STATUS: {
        WAITING: 1,
        DONE: 2
    },

    KNOWLEDGE_FORM_CREATE_TICKET_FOR_OWNER_PERMISSION_TEXT: {
        IN_PROJECT: 'プロジェクト内',
        IN_ORG: '組織内',
        B2B_CUSTOMER: '全B2Bカスタマ―プロジェクト ',
        B2B_SUPPORT: '全B2Bサポートプロジェクト',
        ALL_ORG: '全組織'
    },

    GET_API_PUBLIC_TYPE: {
        PREPARE_DATA_APPROVE_PAGE: 'PREPARE_DATA_APPROVE_PAGE',
        PREPARE_DATA_CONFIRM_ORGANIZATION: 'PREPARE_DATA_CONFIRM_ORGANIZATION',
        PREPARE_DATA_IFRAME_LOGIN: 'PREPARE_DATA_IFRAME_LOGIN',
        PREPARE_DATA_ANONYMOUS_QA: 'PREPARE_DATA_ANONYMOUS_QA',
        VERIFY_CREATE_TICKET_ANONYMOUS_QA: 'VERIFY_CREATE_TICKET_ANONYMOUS_QA',
        VERIFY_CONFIRM_TICKET_ANONYMOUS_QA: 'VERIFY_CONFIRM_TICKET_ANONYMOUS_QA',
        GET_FIELD_IN_FORM_FOR_ANONYMOUS_QA: 'GET_FIELD_IN_FORM_FOR_ANONYMOUS_QA',
        PREPARE_DATA_CONFIRM_FORGOT_PASSWORD: 'PREPARE_DATA_CONFIRM_FORGOT_PASSWORD',
        PREPARE_DATA_TICKET_FOR_GUEST_CONTRACT: 'PREPARE_DATA_TICKET_FOR_GUEST_CONTRACT',
        PREPARE_DATA_ORGANIZATION_LOGIN: 'PREPARE_DATA_ORGANIZATION_LOGIN',
        VERIFY_DATA_ORGANIZATION_LOGIN: 'VERIFY_DATA_ORGANIZATION_LOGIN',
        GET_FIELD_CHILD_DATA: 'GET_FIELD_CHILD_DATA',
        VALIDATE_PUBLIC_KNOWLEDGE_URL: 'VALIDATE_PUBLIC_KNOWLEDGE_URL',
        GET_PUBLIC_KNOWLEDGE_DRILLDOWN_DATA: 'GET_PUBLIC_KNOWLEDGE_DRILLDOWN_DATA',
        GET_FORM_BY_ID: 'GET_FORM_BY_ID',
        PREPARE_DATA_LIST_VIEW_TAB_PUBLIC_KNOWLEDGE: 'PREPARE_DATA_LIST_VIEW_TAB_PUBLIC_KNOWLEDGE',
        GET_PUBLIC_KNOWLEDGE_LIST: 'GET_PUBLIC_KNOWLEDGE_LIST',
        GET_PUBLIC_KNOWLEDGE_DETAIL_LIST: 'GET_PUBLIC_KNOWLEDGE_DETAIL_LIST',
        PREPARE_DATA_PUBLIC_KNOWLEDGE_DETAIL: 'PREPARE_DATA_PUBLIC_KNOWLEDGE_DETAIL',
        GET_LIST_MASTER_KNOWLEDGE_OF_FORM: 'GET_LIST_MASTER_KNOWLEDGE_OF_FORM',
        GET_LIST_FORM_OPTIONS_CHATBOT: 'GET_LIST_FORM_OPTIONS_CHATBOT',
        PREPARE_DATA_SETTING_PUBLIC_KNOWLEDGE: 'PREPARE_DATA_SETTING_PUBLIC_KNOWLEDGE',
        GET_LIST_PUBLIC_KNOWLEDGE_CHAT_BOT: 'GET_LIST_PUBLIC_KNOWLEDGE_CHAT_BOT',
        GET_PUBLIC_KNOWLEDGE_DRILLDOWN_DATA_FOR_CHATBOT:
            'GET_PUBLIC_KNOWLEDGE_DRILLDOWN_DATA_FOR_CHATBOT',
        GET_LIST_SUPPORT_CHAT_POT: 'GET_LIST_SUPPORT_CHAT_POT',
        PREPARE_DATA_CHAT_BOT: 'PREPARE_DATA_CHAT_BOT',
        GET_CHAT_BOT_CATEGORY_TAG_FIELD_LIST: 'GET_CHAT_BOT_CATEGORY_TAG_FIELD_LIST',
        GET_CHAT_BOT_CATEGORY_LIST: 'GET_CHAT_BOT_CATEGORY_LIST',
        GET_INFO_FORM_FIELD: 'GET_INFO_FORM_FIELD',
        GET_LIST_CATEGORY_AND_SETTING_CHATBOT: 'GET_LIST_CATEGORY_AND_SETTING_CHATBOT',
        VERIFY_B2C_PASSWORD: 'VERIFY_B2C_PASSWORD',
        GET_PROJECT_ALIAS_AND_SUB_DOMAIN_BY_PROJECT_ID:
            'GET_PROJECT_ALIAS_AND_SUB_DOMAIN_BY_PROJECT_ID',
        GET_FORM_QA_SYSTEM: 'GET_FORM_QA_SYSTEM',
        GET_LIST_AGENT_DATA: 'GET_LIST_AGENT_DATA',
        VALIDATE_TELEPHONE_AGENT_ENABLED: 'VALIDATE_TELEPHONE_AGENT_ENABLED',
        VALIDATE_TRAINING_TELEPHONE_ENABLED: 'VALIDATE_TRAINING_TELEPHONE_ENABLED',
        PREPARE_DATA_REGISTER_TRIAL: 'PREPARE_DATA_REGISTER_TRIAL',
        GET_OUTLINE_FIELD: 'GET_OUTLINE_FIELD',
        GET_PROJECT_EMAIL_SETTING: 'GET_PROJECT_EMAIL_SETTING',
        GET_TITLE_OF_TICKET_PROMPT: 'GET_TITLE_OF_TICKET_PROMPT',
        GET_LIST_CHAT_THREAD: 'GET_LIST_CHAT_THREAD',
        GET_LIST_GPT_MODEL: 'GET_LIST_GPT_MODEL',
        GET_TAG_CHILD_WITH_SHORTENED_DATA: 'GET_TAG_CHILD_WITH_SHORTENED_DATA',
        GET_DATA_SHARE_LINK_BY_TARGET_ID: 'GET_DATA_SHARE_LINK_BY_TARGET_ID',
        GET_DATA_SHARE_LINK_BY_SHORT_KEY: 'GET_DATA_SHARE_LINK_BY_SHORT_KEY',
        GET_LIST_ATTACH_FILE_BY_AI_CHAT_POST: 'GET_LIST_ATTACH_FILE_BY_AI_CHAT_POST',
        GET_NAME_TAB_CHAT_AI_WHEN_FIRST_MSG_NO_CONTENT: 'GET_NAME_TAB_CHAT_AI_WHEN_FIRST_MSG_NO_CONTENT',
        DRILLDOWN_GET_TAG_CHILD: 'DRILLDOWN_GET_TAG_CHILD',
        DRILLDOWN_GET_SUGGEST_TAG_OPTIONS: 'DRILLDOWN_GET_SUGGEST_TAG_OPTIONS',
        GET_MANAGEMENT_BUSINESS_APP_LIST: 'GET_MANAGEMENT_BUSINESS_APP_LIST',
        GET_TICKET_BUSINESS_APP_LIST: 'GET_TICKET_BUSINESS_APP_LIST',
        GET_TICKET_BUSINESS_APP_DETAIL: 'GET_TICKET_BUSINESS_APP_DETAIL',
        GET_TICKET_BUSINESS_APP_BY_IDS: 'GET_TICKET_BUSINESS_APP_BY_IDS',
        GET_FORM_BY_IDS: 'GET_FORM_BY_IDS',
        GET_PROJECT_BY_IDS: 'GET_PROJECT_BY_IDS',
        GET_TICKET_OPERATOR_ELS_DATA: 'GET_TICKET_OPERATOR_ELS_DATA',
        GET_CALL_HANDLER_DEFAULT_VALUE: 'GET_CALL_HANDLER_DEFAULT_VALUE',
    },

    DRILLDOWN_DEFAULT_TAGS_VISIBLE_COUNT: 30,
    DRILLDOWN_SUGGEST_OPTION_VISIBLE_SIZE: 15,
    DEFAULT_TAGS_VISIBLE_COUNT: 30,
    
    UPDATE_API_PUBLIC_TYPE: {
        PUSH_LOG_CLIENT: 'PUSH_LOG_CLIENT',
        ANONYMOUS_END_LIVE_CHAT: 'ANONYMOUS_END_LIVE_CHAT',
        PING_SERVER_CONTENT: 'PING_SERVER_CONTENT',
        DELETE_S3_FILE_BY_PATH: 'DELETE_S3_FILE_BY_PATH',
        REMOVE_UPLOAD_S3_FILE_LIST: 'REMOVE_UPLOAD_S3_FILE_LIST',
        UPDATE_CHATPOST_RESOURCE: 'UPDATE_CHATPOST_RESOURCE',
        CREATE_OR_UPDATE_AI_CHATPOST: 'CREATE_OR_UPDATE_AI_CHATPOST'
    },

    PUBLIC_KNOWLEDGE_PAGE: {
        PAGE_SIZE: 30
    },

    LIMIT_DISPLAY_PAGE: {
        SIZE: 5
    },

    GET_USER_LIST_METHOD: {
        GET_USER_LIST_IN_USER_MANAGEMENT: 'GET_USER_LIST_IN_USER_MANAGEMENT',
        GET_ADMIN_LIST_IN_ORG: 'GET_ADMIN_LIST_IN_ORG',
        GET_USER_LIST_BY_ID_LIST: 'GET_USER_LIST_BY_ID_LIST',
    },

    PUBLIC_KNOWLEDGE_SORT_TYPE: {
        CREATED_AT: '投稿日新しい順',
        UPDATED_AT: '更新日新しい順',
        TOTAL_PRIVATE_BOOKMARK_ASC: '個人用ブックマーク件数が少ない順',
        TOTAL_PRIVATE_BOOKMARK_DESC: '個人用ブックマーク件数が多い順',
        PAGE_UNIT_ASC: 'ページ番号順'
    },

    SETTING_CHAT_BOT: {
        MAX_LENGTH: 20000,
        LOGO_ICON_DEFAULT: '/assets/image/chatbot.svg',
        LOGO_ICON_WHITE: '/assets/image/chatbot-white.svg',
        SEND_LOGO: '/assets/image/icon-send.svg',
        NUMBER_HIT_KNOWLEDGE_TICKET: {
            MAX: 99,
            MIN: 1,
            DEFAULT: 5
        },
        MAX_LENGTH_ANSWER: {
            MIN: 1,
            MAX: 10,
            DEFAULT: 4
        },
        MIN_NUMBER_IN_ANSWER: 1,
        ACTION_WHEN_NOT_RESOLVE: {
            CREATE_TICKET_AND_CHAT_WITH_AGENT: 1, // チケット発行してライブチャットを行う
            CREATE_TICKET_AND_FINISH: 2, // チケット発行して終了する
            DISPLAY_FREE_MESSAGE: 3 // 自由メッセージを表示する
        },
        MAX_OPTION_DISPLAY_LENGTH: {
            MIN: 1,
            MAX: 50,
            DEFAULT: 14
        }
    },
    DEFAULT_CHATBOT_MESSAGE_TYPE: {
        LIST_FORM: 1,
        LIST_TAG_FIELD: 2,
        LIST_TAG_ITEM: 3,
        LIST_TICKET: 4,
        CONFIRM_ISSUES_RESOLVED: 5,
        THE_END: 6,
        FREE_MESSAGE: 7,
        LOADING_GET_LIST_TAG_FIELD: 9,
        SELECT_CATEGORY: 10,
        FORM_QA_IN_CHATBOT: 11,
        BACK_TO_BEGIN: 12,
        CONTENT_QA_CHATBOT: 13,
        SELECT_TAG_ITEM: 14,
        QA_FORM_OPTION_LIVE_CHAT: 15,
        CONNECTING: 16,
        LIVE_CHAT_FORM_ME: 17,
        CONNECTED: 18,
        AGENT_MESSAGE: 19,
        LIVE_CHAT: 20,
        NOT_FOUND_AGENT: 21,
        BACK_TO_BEGIN_AFTER_REJECT: 22,
        FILE_UPLOADED: 23,
        END_LIVE_CHAT: 24,
        LIVE_CHAT_MENTION: 25,
        SELECT_TAG_FIELD: 26,
        USER_SEND_CHAT_AI: 27,
        GPT_RESPONSE_MESSAGE: 28,
        SUGGEST_USING_AI: 29,
        MSG_FILES_WITH_IMAGES: 30
    },
    FETCH_ATTACH_FILES: {
        MAX_RETRY: 10,
        RETRY_DELAY: 1000
    },
    MIN_LENGTH_LIST_TICKET_CHATBOT: 5,
    CHATBOT_ACTION: {
        OPEN_CHATBOT: 'OPEN_CHATBOT',
        CLOSE_CHATBOT: 'CLOSE_CHATBOT',
        ZOOMIN_CHATBOT: 'ZOOMIN_CHATBOT',
        ZOOMOUT_CHATBOT: 'ZOOMOUT_CHATBOT',
        FINISHED_RENDER_CHATBOT: 'FINISHED_RENDER_CHATBOT'
    },

    CHATBOT_ACTOR: {
        ANONYMOUS: 'ANONYMOUS',
        AGENT: 'AGENT',
        SYSTEM: 'SYSTEM'
    },

    REMOVE_TICKET_TYPE: {
        LIVE_CHAT: 'LIVE_CHAT'
    },

    TICKET_PREFIX: {
        REQ: 'req_',
        KNOWLEDGE: 'knowledge'
    },

    UPLOAD_CSV_KNOWLEDGE: {
        DEFAULT_LINE: 0,
        MIN_CURRENT_LINE: 2,
        MIN_LAYER: 1,
        // MAX_LAYER:9,
        MAX_LAYER: 2,
        MAX_MB_FILE_UPLOAD: 50,
        STATUS_INITIAL: 'status_initial',
        STATUS_START: 'status_start',
        STATUS_PAUSE: 'status_pause',
        STATUS_SUCCESS: 'status_success',
        DEFAULT_SELECTED_MAPPING: 0,
        FILE_TYPE_DEFAULT: 'pdf,tiff,tif,jpeg,jpg,jfif,jfi,jif,bmp,png',
        MAX_LENGTH_FILE_TYPES: 256,
        MAX_LENGTH_AUTHENTICATION: 128,
        LAYER_SETTINGS: 'layer_settings',
        FILE_TYPE_SETTINGS: 'file_type_settings',
        USER_NAME_SETTINGS: 'user_name_settings',
        PASSWORD_SETTINGS: 'password_settings',
        TYPE_IMPORT_CSV: {
            NO_OVERWRITE: 1,
            KNOWLEDGE_ID: 2,
            FIELD_OF_FORM: 3
        },
        TYPE_OVERWRITE_ATTACH_FILE: {
            UPDATE: 1,
            ADD: 2,
            NO_CHANGE: 3
        },
        AUTO_CREATE_TAG_ITEM: {
            CREATE: 1,
            NOT_CREATE: 0
        }
    },
    INVITED_GENERAL_ID_RANGE: {
        MIN: 1,
        MAX: 999
    },
    DEFAULT_PATH_STYLE_PUBLIC_KNOWLEDGE_SETTINGS: 'assets/public-knowledge-default-style.css',
    DEFAULT_PATH_STYLE_KNOWLEDGE_ROBO_SETTINGS: 'assets/knowledge-robo-default-style.css',
    CHAT_THREAD_MAX_MB_FILE_UPLOAD: 500,
    B2B_INVITATION_STATUS: {
        APPROVED: 'APPROVED',
        WAITING: 'WAITING',
        REJECTED: 'REJECTED'
    },

    CHAT_BOT_ORIGIN: {
        PUBLIC_KNOWLEDGE_SITE: 'PUBLIC_KNOWLEDGE_SITE',
        GEN_SCRIPT: 'GEN_SCRIPT'
    },
    REASON_CAN_NOT_ACCESS_TICKET: {
        TICKET_DELETED: 'isTicketDeleted',
        INVALID_URL: 'isInValidUrl',
        CORP_INACTIVE: 'isCorporationInactive',
        DELETED_CONTENT: 'MSG-CM-DELETED-CONTENT',
        DONT_HAVE_PERMISSION: 'KNOWDEMSG005',
        DELETED_MESSAGE: 'MSG-CM-DELETED-MESSAGE',
        DONT_HAVE_PERMISSION_BY_CHATPOST: 'DONT_HAVE_PERMISSION_BY_CHATPOST'
    },

    ROOT_CORPORATION: {
        COMPONENT_BASIC_INFO: 'COMPONENT_BASIC_INFO',
        COMPONENT_CONTRACT_DETAILS: 'COMPONENT_CONTRACT_DETAILS',
        TOOL_BAR: {
            CONTRACT_INFO: 'CONTRACT_INFO',
            RESOURCE_USAGE: 'RESOURCE_USAGE',
            OPTION_USAGE: 'OPTION_USAGE',
            PROVIDE_FUNCTION: 'PROVIDE_FUNCTION',
            INVIDUAL_BASIC_SETTING: 'INVIDUAL_BASIC_SETTING'
        },
        RESOURCE_LIST: {
            LABEL_LASTEST_LOGIN_TIME: 'LABEL-LASTEST-LOGIN-TIME',
            LABEL_GENERAL_ID_NUMBER: 'LABEL-GENERAL-ID-NUMBER',
            LABEL_INTERNAL_ID: 'LABEL-INTERNAL-ID',
            LABEL_PARTNER_ID: 'LABEL-PARTNER-ID',
            LABEL_UNASSIGNED_ID: 'LABEL-UNASSIGNED-ID',
            LABEL_INTERNAL_CUSTOMER_ID_NUMBER: 'LABEL-INTERNAL-CUSTOMER-ID-NUMBER',
            LABEL_B2C_ID_NUMBER: 'LABEL-B2C-ID-NUMBER',
            LABEL_B2B_ID_NUMBER: 'LABEL-B2B-ID-NUMBER',
            LABEL_PROJECT_NUMBER: 'LABEL-PROJECT-NUMBER',
            LABEL_GENERAL_PROJECT_NUMBER: 'LABEL-GENERAL-PROJECT-NUMBER',
            LABEL_INTERNAL_DESK_NUMBER: 'LABEL-INTERNAL-DESK-NUMBER',
            LABEL_PUBLIC_DESK_NUMBER: 'LABEL-PUBLIC-DESK-NUMBER',
            LABEL_QA_COUNTER_NUMBER: 'LABEL-Q&A-COUNTER-NUMBER',
            LABEL_SUPPORT_COUNTER_NUMBER: 'LABEL-SUPPORT-COUNTER-NUMBER',
            LABEL_PUBLIC_KNOWLEDGE_SITE_NUMBER: 'LABEL-PUBLIC-KNOWLEDGE-SITE-NUMBER',
            LABEL_KNOWLEDGE_ROBO_NUMBER: 'LABEL-KNOWLEDGE-ROBO-NUMBER',
            LABEL_QA_TICKET_NUMBER: 'LABEL-Q&A-TICKET-NUMBER',
            LABEL_KNOWLEDGE_TICKET_NUMBER: 'LABEL-KNOWLEDGE-TICKET-NUMBER',
            LABEL_FORMAT_NUMBER: 'LABEL-FORMAT-NUMBER',
            LABEL_STORAGE_USAGE_NUMBER: 'LABEL-STORAGE-USAGE-NUMBER',
            LABEL_EXTERNAL_WEB_API_CALLS_NUMBER: 'LABEL-EXTERNAL-WEB-API-CALLS-NUMBER'
        },

        OPTION_USAGE: {
            LABEL_ADVANCED_NUMBER_OF_TICKET: 'LABEL-ADVANCED-NUMBER-OF-TICKET',
            LABEL_ADVANCED_NUMBER_OF_KNOWLEDGE: 'LABEL-ADVANCED-NUMBER-OF-KNOWLEDGE',
            LABEL_ADVANCED_STORAGE: 'LABEL-ADVANCED-STORAGE',
            LABEL_ADVANCED_NUMBER_OF_QA_COUNTER: 'LABEL-ADVANCED-NUMBER-OF-QA-COUNTER',
            LABEL_ADVANCED_NUMBER_OF_SUPPORTED_COUNTER: 'LABEL-ADVANCED-NUMBER-OF-SUPPORTED-COUNTER'
        },

        PROVIDE_FUNCTION: {
            LABEL_FUNCTION_INTERNAL_QA_COUNTER_SETTINGS:
                'LABEL-FUNCTION-INTERNAL-Q&A-COUNTER-SETTINGS',
            LABEL_FUNCTION_PUBLIC_SERVICE_DESK_SETTINGS:
                'LABEL-FUNCTION-PUBLIC-SERVICE-DESK-SETTINGS',
            LABEL_FUNCTION_PUBLIC_WEB_FORM: 'LABEL-FUNCTION-PUBLIC-WEB-FORM',
            LABEL_FUNCTION_EMAIL_RESPONSE_FUNCTION: 'LABEL-FUNCTION-EMAIL-RESPONSE-FUNCTION',
            LABEL_FUNCTION_SOLUTIONDESK_KNOWLEDGE: 'LABEL-FUNCTION-SOLUTIONDESK-KNOWLEDGE',
            LABEL_FUNCTION_CONVERT_PDF: 'LABEL-CONVERT-PDF',
            LABEL_FUNCTION_SYNONYM_SEARCH: 'LABEL-SYNONYM-SEARCH',
            LABEL_BATCH_COMMAND: 'LABEL-BATCH-COMMAND',
            LABEL_FUNCTION_CHAT_AI: 'LABEL-CHAT-AI',
            LABEL_FUNCTION_LINCENSE_KEY_PERMISSION: 'LABEL-LINCENSE-KEY-PERMISSION',
            LABEL_FUNCTION_AI_AUTO: 'LABEL_FUNCTION_AI_AUTO',
            LABEL_FUNCTION_SD_AUTO: 'LABEL_FUNCTION_SD_AUTO',
            LABEL_FUNCTION_MCP_SERVER: 'LABEL_FUNCTION_MCP_SERVER',
            LABEL_FUNCTION_EXTERNAL_WEB_API: 'LABEL_FUNCTION_EXTERNAL_WEB_API',
            LABEL_FUNCTION_PUBLIC_KNOWLEDGE_SITE: 'LABEL-FUNCTION-PUBLIC-KNOWLEDGE-SITE',
            LABEL_FUNCTION_KNOWLEDGE_BOT: 'LABEL-FUNCTION-KNOWLEDGE-BOT',
            LABEL_FUNCTION_TASK_MNG: 'LABEL-FUNCTION-TASK-MNG',
            LABEL_FUNCTION_ADVANCED_SETTINGS: 'LABEL-FUNCTION-ADVANCED-SETTINGS',
            LABEL_FUNCTION_LOG_ANALYSIS: 'LABEL-FUNCTION-LOG-ANALYSIS',
            LABEL_FUNCTION_IP_RESTRICTION: 'LABEL-FUNCTION-IP-RESTRICTION',
            LABEL_FUNCTION_MULTI_AUTH: 'LABEL-FUNCTION-MULTI-AUTH',
            LABEL_FUNCTION_TELEPHONE_AGENT: 'LABEL-FUNCTION-TELEPHONE-AGENT',
        },

        INVIDUAL_BASIC_SETTING: {
            LABEL_BASIC_NUMBER_OF_TICKET: 'LABEL-BASIC-NUMBER-OF-TICKET',
            LABEL_BASIC_NUMBER_OF_KNOWLEDGE: 'LABEL-BASIC-NUMBER-OF-KNOWLEDGE',
            LABEL_BASIC_NUMBER_OF_FORM: 'LABEL-BASIC-NUMBER-OF-FORM',
            LABEL_BASIC_NUMBER_OF_QA_COUNTER: 'LABEL-BASIC-NUMBER-OF-QA-COUNTER',
            LABEL_BASIC_NUMBER_OF_SUPPORTED_COUNTER: 'LABEL-BASIC-NUMBER-OF-SUPPORTED-COUNTER',
            LABEL_BASIC_NUMBER_OF_GENERAL_PRJ: 'LABEL-BASIC-NUMBER-OF-GENERAL-PRJ',
            LABEL_BASIC_NUMBER_OF_INTERNAL_CUSTOMER: 'LABEL-BASIC-NUMBER-OF-INTERNAL-CUSTOMER',
            LABEL_BASIC_NUMBER_OF_B2C: 'LABEL-BASIC-NUMBER-OF-B2C',
            LABEL_BASIC_STORAGE: 'LABEL-BASIC-STORAGE',
            LABEL_BASIC_GENERAL_USER_FEE: 'LABEL-BASIC-GENERAL-USER-FEE',
            LABEL_BASIC_CHARGE: 'LABEL-BASIC-CHARGE',
            LABEL_BASIC_EXTERNAL_WEB_API: 'LABEL-BASIC-EXTERNAL-WEB-API',
        },

        INVIDUAL_BASIC_SETTING_VALID: {
            MIN_VALUE: 0,
            MAX_LENGTH: 8
        }
    },

    GET_CORPORATION_CONTRACT_DETAIL_METHOD: {
        GET_CORPORATION_AND_CONTRACT_DATA: 'GET_CORPORATION_AND_CONTRACT_DATA',
        GET_CORPORATION_AND_CONTRACT_DATA_TO_VIEW_AND_UPDATE:
            'GET_CORPORATION_AND_CONTRACT_DATA_TO_VIEW_AND_UPDATE',
        GET_CORPORATION_LIST_USER: 'GET_CORPORATION_LIST_USER'
    },

    AI_SETTING_RANGE: {
        IN_PROJECT: 'IN_PROJECT',
        IN_ORG: 'IN_CORPORATION',
        OUT_ORG: 'OUT_CORPORATION'
    },

    AI_TEMPERATURE_DEFAULT: 1,

    MAX_AI_CHAT_KNOWLEDGE_COUNT_DEFAULT: 5,
    MAX_AI_CHAT_KNOWLEDGE_COUNT_MIN: 1,
    MAX_AI_CHAT_KNOWLEDGE_COUNT_MAX: 1000,

    USER_PERMISSION_VIEW_KNOWLEDGE: {
        MEMBER_OF_PROJECT: 'MEMBER_OF_PROJECT',
        PERSONAL_PROJECT: 'PERSONAL_PROJECT',
        B2C: 'B2C',
        GUEST_PARTNER: 'GUEST_PARTNER',
        GUEST_SUPPORTED: 'GUEST_SUPPORTED'
    },

    KNOWLEDGE_VIEW_OPTION: {
        PRJ_IN_USE: 'PRJ_IN_USE',
        ALL_KNOWLEDGE_IN_ORG: 'ALL_KNOWLEDGE_IN_ORG'
    },
    AI_SYSTEM_FIELD_TARGET_OPTION_TAGS: {
        INTERNAL: 'AIPromptApplicationTargetInternal',
        EXTERNAL: 'AIPromptApplicationTargetExternal'
    },
    KNOWLEDGE_SORT_TYPE: {
        CREATED_AT: 'コンテンツの投稿日順',
        UPDATED_AT: 'コンテンツの更新日順',
        SIMILAR: 'コンテンツの類似度順',
        PAGE_NO: 'ページ番号順',
        TOTAL_PRIVATE_BOOKMARK_ASC: '個人用ブックマーク件数が少ない順',
        TOTAL_PRIVATE_BOOKMARK_DESC: '個人用ブックマーク件数が多い順'
    },
    METHOD: 'method',

    AI_PROMPT_SCOPED: {
        INTERNAL_PRJ: 'inPrj',
        EXTERNAL_PRJ: 'outPrj'
    },

    SETTING_AI_PROMPT_ACTION: {
        UPDATED_USAGE_PROMPT: 'promptUsage',
        SETTING_BASIC_PROMPT: 'basicPrompt',
        DELETED_BASIC_PROMPT: 'deletePrompt'
    },

    VECTOR_DATA_STATUS: {
        DOING: 'DOING',
        DONE: 'DONE'
    },
    AI_PROMPT_VALID_CODE: {
        MSG_CM_INVALID_LINK: 'MSG-AI-PASTED-LINK-ARE-NOT-PROMPT-KNOWN',
        MSG_CM_INVALID_LINK_INTERATOR: "MSG-AI-PASTED-LINK-ARE-NOT-PROMPT-KNOWN-INTERATOR",
    },
    AI_PROMPT: {
        AI_PROMPT_BODY: 'AIPromptBody',
        APPLY_AI_PROMPT: 'ApplyAIprompt',
        AI_PROMPT_APPLICATION_TARGET: 'AIPromptApplicationTarget'
    },
    UPDATED_ROOT_ORG_CODE_FAIL: {
        MSG_CM_BLOCKED_ORG: 'MSG-CM-BLOCKED-ORG',
        MSG_CM_DELETED_ORG: 'MSG-CM-DELETED-ORG',
        MSG_VERSION_HAVE_BEEN_DELETED: 'MSG-VERSION-HAVE-BEEN-DELETED'
    },
    SPLIT_PDF_SETTING: {
        ON: 1,
        OFF: 0
    },
    PDF_FUNCTION: {
        ON: 1,
        OFF: 0
    },
    DEFAULT_OUTLINE: '概要(現在未記入)',
    ATTACHMENT_DISPLAY_LIMIT: 3,
    RICHTEXT_MAX_LENGTH: 350000,
    MAX_SIZE_KB_FIELD: 350,
    CHATBOT_ORIGIN: {
        CHATBOT: 'chatbot'
    },
    KEY_FILE_CSS_TYPE: {
        PUBLIC_KNOWLEDGE_SITE: 0,
        KNOWLEDGE_ROBO: 1
    },
    COMMAND_CSV: {
        LINUX_PATH: 'command/sdimport.sh',
        WINDOWS_PATH: 'command/sdimport.ps1',
        README_PATH: 'command/README.md'
    },
    LICENSE_KEY_STATUS: {
        EXPIRED: 'EXPIRED',
        USING: 'USING'
    },
    NOT_ROOT_SETTING_KEY: '**********',

    TASK_STATUS: {
        WAITING: 0,
        START: 1,
        DONE: 2,
        CRAWLING: 3
    },

    BULK_ACTION: {
        EDIT_TAG_FIELD: 'EDIT_TAG_FIELD',
        EDIT_PUBLIC_RANGE: 'EDIT_PUBLIC_RANGE',
        EXPORT_CSV: 'EXPORT_CSV',
        BACK_TO_DRAFT: 'BACK_TO_DRAFT',
        SENT_TO_PUBLIC: 'SENT_TO_PUBLIC',
        DUPLICATE: 'DUPLICATE',
        RESTORE: 'RESTORE',
        DELETE: 'DELETE',
        SOFT_DELETE: 'SOFT_DELETE',
        HARD_DELETE: 'HARD_DELETE',
        KNOWLEDGE_BOOKMARK_TICKET: 'KNOWLEDGE_BOOKMARK_TICKET',

        HELPDESK_EXPORT_CSV: 'HELPDESK_EXPORT_CSV',
        HELPDESK_BACK_TO_DRAFT: 'HELPDESK_BACK_TO_DRAFT',
        HELPDESK_SENT_TO_PUBLIC: 'HELPDESK_SENT_TO_PUBLIC',
        HELPDESK_DELETE: 'HELPDESK_DELETE',
        HELPDESK_RESTORE: 'HELPDESK_RESTORE',
        HELPDESK_SOFT_DELETE: 'HELPDESK_SOFT_DELETE',
        HELPDESK_HARD_DELETE: 'HELPDESK_HARD_DELETE',
        HELPDESK_ARCHIVE: 'HELPDESK_ARCHIVE',
        HELPDESK_BACK_TO_NEW_SUPPORT: 'HELPDESK_BACK_TO_NEW_SUPPORT',
        HELPDESK_EDIT_TAG_FIELD: 'HELPDESK_EDIT_TAG_FIELD',
        HELPDESK_BOOKMARK_TICKET: 'HELPDESK_BOOKMARK_TICKET',

        DOWNLOAD_UPLOAD_TAG_ITEMS: 'DOWNLOAD_UPLOAD_TAG_ITEMS',
    },

    BULK_ACTION_LIST: [
        { type: 'EDIT_TAG_FIELD', disable: false },
        { type: 'EDIT_PUBLIC_RANGE', disable: false },
        { type: 'EXPORT_CSV', disable: true },
        { type: 'BACK_TO_DRAFT', disable: false },
        { type: 'SENT_TO_PUBLIC', disable: true },
        { type: 'DUPLICATE', disable: true },
        { type: 'DELETE', disable: false },
        { type: 'RESTORE', disable: false }
    ],

    HELPDESK_BULK_ACTION_LIST: [
        { type: 'HELPDESK_EDIT_TAG_FIELD', disable: false },
        { type: 'HELPDESK_EXPORT_CSV', disable: true },
        // { type: 'HELPDESK_BACK_TO_DRAFT', disable: false },
        // { type: 'HELPDESK_SENT_TO_PUBLIC', disable: true },
        { type: 'HELPDESK_DELETE', disable: false },
        { type: 'HELPDESK_RESTORE', disable: false },
        { type: 'HELPDESK_ARCHIVE', disable: false },
        { type: 'HELPDESK_BACK_TO_NEW_SUPPORT', disable: false }
    ],

    BULK_ACTION_ERROR_LIST: {
        MSG_CM_CONTENT_NOT_EXIST: 'MSG-CM-CONTENT-NOT-EXIST',
        MSG_KNOW_EDIT_PERMISSION_EXCEED_VIEW_PERMISSION:
            'MSG-KNOW-EDIT-PERMISSION-EXCEED-VIEW-PERMISSION',
        MSG_CM_TAG_FIELD_NOT_EXIST: 'MSG-CM-TAG-FIELD-NOT-EXIST',
        MSG_CM_TAG_ITEM_NOT_EXIST: 'MSG-CM-TAG-ITEM-NOT-EXIST',
        MSG_CM_DO_NOT_HAVE_PERMISSION: 'MSG-CM-DO-NOT-HAVE-PERMISSION',
        MSG_CM_PUBLIC_RANGE_CAN_NOT_SET: 'MSG-CM-PUBLIC-RANGE-CAN-NOT-SET',
        MSG_CM_REQUIRED_TAG_FIELD_EMPTY: 'MSG-CM-REQUIRED-TAG-FIELD-EMPTY',
        MSG_CM_CONTENT_CAN_NOT_PUBLIC: 'MSG-CM-CONTENT-CAN-NOT-PUBLIC',
        MSG_CM_INVALID_DATA: 'MSG-CM-INVALID-DATA',
        MSG_CM_CANNOT_EDIT_TAG_IN_CALL: 'MSG-CM-CANNOT-EDIT-TAG-IN-CALL'
    },

    LIST_PERMISSION_PUBLIC_RANGE: {
        BASIC_VIEW: '基本閲覧権限',
        BASIC_EDIT: '基本編集権限',
        ADDITIONAL_VIEW: '追加閲覧権限',
        ADDITIONAL_EDIT: '追加編集権限'
    },
    LIST_GROUP_ROLE_PUBLIC_RANGE: {
        BASIC_VIEW: 'BASIC_VIEW',
        BASIC_EDIT: 'BASIC_EDIT',
        PRJ_IN_ORG: 'PRJ_IN_ORG',
        B2B_CUSTOMER: 'B2B_CUSTOMER',
        B2B_SUPPORT: 'B2B_SUPPORT',
        PRJ_OTHER: 'PRJ_OTHER'
    },
    PUBLIC_RANGE_ROLE: {
        IN_ORG: 'orgProject',
        B2B_CUSTOMER: 'b2bCustomerProject',
        B2B_HELPDESK: 'b2bHelpdeskProject',
        BASE_PRJ: 'baseProject',
        GUEST_CUSTOMER_PRJ: 'guestCustomerProject'
    },
    LIMIT_TICKET_UPDATE_MULTI: 10000,
    LIMIT_TICKET_EXPORT: 100000,
    BULK_ACTION_EXPORT_CHAT_THREAD: {
        ON: '1',
        OFF: '0'
    },
    BULK_ACTION_EXPORT_FILE_TYPE: {
        JSON: 'json',
        CSV: 'csv'
    },
    BULK_ACTION_LOG_TICKET_TYPE: {
        KNOWLEDGE: 'KNOWLEDGE',
        HELPDESK: 'HELPDESK'
    },

    BULK_ACTION_DEFAULT_VALUE : {
        TAG_ITEM_DISPLAY: 100
    },

    QUERY_ELS_ACTION_TYPE: {
        GET_MATER_KNOWLEDGE_OF_FORM: 'GET_MATER_KNOWLEDGE_OF_FORM',
        GET_MATER_KNOWLEDGE_OF_FORM_WITH_PAGINATION: 'GET_MATER_KNOWLEDGE_OF_FORM_WITH_PAGINATION',
        GET_TAG_MASTER_CHILD_WITH_SHORTENED_DATA: 'GET_TAG_MASTER_CHILD_WITH_SHORTENED_DATA'
    },
    
    PUSH_LOG_CLIENT_ACTION: {
        CREATE_COOKIE: 'CREATE_COOKIE',
        STORAGE_ERR: 'STORAGE_ERR'
    },

    RESET_ATOM: {
        BULK_ACTION_KNOWLEDGE_TASK_ID: 'bulkActionKnowledgeTaskIdAtom',
        BULK_ACTION_HELPDESK_TASK_ID: 'bulkActionHelpdeskTaskIdAtom',
        PUBLIC_KNOWLEDGE_HIT_NUMBER_TICKET: 'publicKnowledgeHitNumberTicketAtom',
        USER_PERMISSION_TO_VIEW_KNOWLEDGE_ATOM: 'userPermissionToViewKnowledgeAtom',
        FIELD_LIST_OF_CORPORATION_ATOM: 'fieldListOfCorporationAtom'
    },

    CUSTOMER_INVITATION_SETTING: {
        ON: 1,
        OFF: 0
    },
    PANEL_SIZE: {
        SIZE_1: 'SIZE_1',
        SIZE_2: 'SIZE_2',
        SIZE_3: 'SIZE_3',
    },

    NOTI_MAIL_CODE: {
        NOTI_MAIL_CREATE_TICKET_TASK: 'NOTI_MAIL_CREATE_TICKET_TASK',
        NOTI_MAIL_EDIT_TICKET_TASK: 'NOTI_MAIL_EDIT_TICKET_TASK',
        NOTI_MAIL_CHAT_TICKET_TASK: 'NOTI_MAIL_CHAT_TICKET_TASK',
        NOTI_MAIL_MENTION_TO_IN_TICKET_TASK: 'NOTI_MAIL_MENTION_TO_IN_TICKET_TASK',

        NOTI_MAIL_CREATE_TICKET_EMAIL: 'NOTI_MAIL_CREATE_TICKET_EMAIL',
        NOTI_MAIL_EDIT_TICKET_EMAIL: 'NOTI_MAIL_EDIT_TICKET_EMAIL',
        NOTI_MAIL_RECEIVE_EMAIL_FROM_PERSIONAL_AND_CREATE_EMAIL_TICKET: 'NOTI_MAIL_RECEIVE_EMAIL_FROM_PERSIONAL_AND_CREATE_EMAIL_TICKET',
        NOTI_MAIL_RECEIVE_EMAIL_FROM_PROJECT_AND_CREATE_EMAIL_TICKET: 'NOTI_MAIL_RECEIVE_EMAIL_FROM_PROJECT_AND_CREATE_EMAIL_TICKET',
    },

    EMAIL_MAIL_CODE: {
        SEND_MAIL_WHEN_CREATE_EMAIL_TICKET: 'SEND_MAIL_WHEN_CREATE_EMAIL_TICKET'
    },

    PANEL_RESPONSIVE: {
        PC: 1367,
        MOBILE: 926,
    },

    DRILLDOWN_TICKET_TYPE: {
        NOTICE: 'お知らせ',
        QA: '問い合わせ',
        DELEGATE: '問い合わせ代理発行',
        INVITATION: 'サポート窓口追加',
        TASK: 'タスク',
        EMAIL: 'メール',
        TELEPHONE: 'ボイス'
    },

    DRILLDOWN_TYPE_TEXT: {
        TICKET_TYPE: 'ticketType',
        EMAIL_TICKET_ORIGIN: 'emailTicketOrigin',
        FORM: 'form',
        PROJECT_ORIGIN: 'projectOrigin',
        PROJECT_TARGET: 'projectTarget',
        NOTICE_TARGET_USER: 'noticeTargetUser',
        CREATOR: 'creator',
        UPDATOR: 'updator',
        PROXIED_USER: 'proxiedUser',
        PUBLIC_RANGE: 'publicRange',
        LIVE_OR_ARCHIVED: 'liveOrArchived',
        PERSON_IN_CHARGE: 'personInCharge',
        TELEPHONE_EVALUATOR: 'telephoneEvaluator',
        SUFFIX_OF_ATTACHMENTS: 'suffixOfAttachments',
        PRIVATE_BOOKMARK: 'privateBookmark',
        SHARED_BOOKMARK: 'sharedBookmark',
        SETTING_MCP_SERVER: 'mcpServerSetting'
    },
    IFRAME_SETTING: {
        COMPLETED_SEND_TICKET_MESSAGE: 'messageCompletedSendTicket',
        COMPLETED_SEND_TICKET_SUBJECT_MAIL: 'subjectMailCompletedSendTicket',
        COMPLETED_SEND_TICKET_CONTENT_MAIL: 'contentMailCompletedSendTicket'
    },

    IFRAME_ALLOW_PERMISSIONS: 'camera; microphone; geolocation; clipboard-read; clipboard-write; fullscreen',

    NOTIFICATION_SETTING_RECEIVED_TYPE: {
        TICKET: 'ticket',
        CHAT_MSG: 'chatMsg'
    },

    SCREEN_DEVICE: {
        MOBILE: 'mobile',
        TABLET: 'tablet',
        DESKTOP: 'desktop',
    },

    DEFAULT_BOOKMARK_NAME: 'あとで見る',
    BOOKMARK_DEFINITION: {
        SYSTEM: "SYSTEM",
        USER: 'USER'
    },
    BOOKMARK_TARGET_TYPE: {
        KNOWLEDGE: 'KNOWLEDGE',
        TICKET: 'TICKET'
    },

    BOOKMARK_UPDATE_API_ACTION: {
        ADD_DEFAULT_BOOKMARK_IN_TICKET_LIST: 'ADD_DEFAULT_BOOKMARK_IN_TICKET_LIST',
        REMOVE_DEFAULT_BOOKMARK_IN_TICKET_LIST: 'REMOVE_DEFAULT_BOOKMARK_IN_TICKET_LIST',
        ADD_AND_UPDATE_MULTI_BOOKMARK: 'ADD_AND_UPDATE_MULTI_BOOKMARK'
    },

    BOOKMARK_GET_API_ACTION: {
        GET_ALL_BOOKMARK_USER_CAN_USE: 'GET_ALL_BOOKMARK_USER_CAN_USE',
        GET_ALL_PRIVATE_BOOKMARK_OF_USER: 'GET_ALL_PRIVATE_BOOKMARK_OF_USER',
        GET_ALL_SHARE_BOOKMARK_OF_PROJECT: 'GET_ALL_SHARE_BOOKMARK_OF_PROJECT',
        GET_ALL_SHARE_BOOKMARK_OF_USER: 'GET_ALL_SHARE_BOOKMARK_OF_USER',
        GET_ALL_BOOKMARK_USER_CAN_USE_TO_BULK_ACTION: 'GET_ALL_BOOKMARK_USER_CAN_USE_TO_BULK_ACTION',
    },

    BOOKMARK_SHARE_RANGE: {
        PRIVATE: 1,
        SHARE_IN_PROJECT: 2
    },

    UPDATE_ELS_FLAG: {
        DEFAULT: 0,
        EVENT: 1,
        REALTIME: 2,
    },

    BOOKMARK_ACTION: {
        EDIT: 'EDIT',
        SHARE: 'SHARE',
        UNSHARE: 'UNSHARE',
        DELETE: 'DELETE',
    },

    BOOKMARK_PREFIX: {
        TEMP: 'temp',
        USER: 'user',
        PROJECT: 'project'
    },

    BREAKLINE_REGEX: /\r?\n|\r|\n/g,
    IPV4_FORMAT_REGEX: /^(?=\d+\.\d+\.\d+\.\d+$)(?:(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\.?){4}$/,
    NUMBER_REGEX: /^\d+$/,

    TYPE_LAST_FORM: {
        LAST_FORM_QA: 'lastFormQA',
        LAST_FORM_NOTICE: 'lastFormNotice',
        LAST_FORM_DELEGATE: 'lastFormDelegate',
        LAST_FORM_INVITED_QA: 'lastFormInvitedQA',
        LAST_FORM_INVITED: 'lastFormInvited',
        LAST_FORM_TASK: 'lastFormTask',
        LAST_FORM_KNOWLEDGE: 'lastFormKnowledge',
        LAST_FORM_EMAIL: 'lastFormEmail'
    },

    DRILLDOWN_TYPE: {
        EMAIL_TICKET_ORIGIN: 'emailTicketOrigin',
        EMAIL_TICKET_SDESK_SEND: 'EMAIL_TICKET_SDESK_SEND',
        EMAIL_TICKET_SDESK_RECEIVE: 'EMAIL_TICKET_SDESK_RECEIVE',
    },

    CONVERT_RATE: {
        MB_TO_B: 1000000
    },

    TICKET_NO_TITLE: '概要 (現在未記入)',
    DEFAULT_TICKET_NO_TITLE: '[概要 (現在未記入)]',
    EMAIL_TICKET_NO_TITLE: '件名(現在未記入)',
    APP_TICKET_NO_TITLE: 'アプリ名 (現在未記入)',

    LIMIT_VALUE_VALIDATE : {
        MB_FILE_UPLOAD_FOR_EMAIL_TICKET: 7.5,
    },

    DELIVER_STATUS: {
        DELIVER: 1,
        UNDELIVER: 0
    },

    EMAIL_PROJECT_NAME_PREFIX: 'project_name_',

    SETTING_AI_DEFAULT: {
        CHATGPT_MODEL: 'GPT-4o',
        CHATGPT_MODEL_ID: 'gpt-4o',
        KNN_VALUE: '10',
        MIN_SCORE: '0.65'
    },
    
    IP_ERRORS:{
        IP_REFUSE_ERROR: 'IP_REFUSE_ERROR'
    },
    FUNCTION_CALLING_LIST : {
        KNOWLEDGE_READ: 'knowledge_read',
        KNOWLEDGE_WRITE: 'knowledge_write',
        KNOWLEDGE_IMPORT: 'knowledge_import',
        KNOWLEDGE_EXPORT: 'knowledge_export',
        KNN_SEARCH: 'knn_search',
        S3JSON_READ: 'S3JSON_read',
        S3JSON_ADD: 'S3JSON_add',
        S3JSON_NEW:'S3JSON_new',
        S3JSON_S3JSON_READ_ADD_KNN: 'S3JSON_read_add_knn',
        TICKET_READ: 'ticket_read',
        TICKET_WRITE: 'ticket_write',
        TICKET_IMPORT: 'ticket_import',
        TICKET_EXPORT: 'ticket_export',
        CALL_EXTERNAL_API: 'call_external_api',
    },
    KNOWLEDGE_PROMPT_FLAG: {
        IS_PROMPT: 1,
        IS_NOT_PROMPT: 0,
    },

    PROMPT_FLAG : {
        TRUE: 1,
        FALSE: 0
    },

    FORM_VARIANT: {
        AI_AUTO: {
            EVENT: "AI_AUTO_EVENT",
            TIMER: "AI_AUTO_TIMER",
            PERIODIC: "AI_AUTO_PERIODIC"
        },
        SD_AUTO: "SD_AUTO",
        BUSINESS_APP: "BUSINESS_APP",
        AI_TELEPHONE_PROMPT: "AI_TELEPHONE_PROMPT",
        AI_TRAINING_PROMPT: "AI_TRAINING_PROMPT",
        AI_ASSISTANT_PROMPT: "AI_ASSISTANT_PROMPT",
        TELEPHONE_FORMAT: "TELEPHONE_FORMAT"
    },

    ONLY_DRILLDOWN_SYSTEM_FIELD: {
        SYSTEM_FIELD: {
            SYSTEM_TAGS_FORM: "system_tags_form",
            CREATOR: "creator",
            UPDATOR: "updator",
            SUFFIX_OF_ATTACHMENTS: "suffixOfAttachments",
            PRIVATE_BOOKMARK: "privateBookmark",
            SHARED_BOOKMARK: "sharedBookmark",
            TICKET_TYPE_CATEGORY: "ticket_type_category",
            INQUIRY_SOURCE_PROJECT: "inquiry_source_project",
            NOTICE_TARGET_PROJECT: "notice_target_project",
            NOTICE_TARGET_USER: "notice_target_user",
            EMAIL_ORIGIN: "email_origin",
            ACTIVE_ARCHIVED_STATUS: "active_archived_status",
            POST_TARGET_PROJECT: "post_target_project",
            FIELD_QA_CATEGORY: "field_qa_category"
        }
    },

    DRILLDOWN_SYSTEM_FIELD: {
            SYSTEM_TAGS_FORM: "system_tags_form",           // フォーマット名
            CREATOR: "creator",                 // 投稿ユーザー
            UPDATOR: "updator",                 // 更新ユーザー
            SUFFIX_OF_ATTACHMENTS: "suffixOfAttachments",     // 添付データ種類
            PRIVATE_BOOKMARK: "privateBookmark",         // 個人用ブックマークタグ
            SHARED_BOOKMARK: "sharedBookmark",          // 共有ブックマークタグ
            
            // Field chỉ có ở ticket drilldown
            TICKET_TYPE_CATEGORY: "ticket_type_category",              // チケット種類
            INQUIRY_SOURCE_PROJECT: "inquiry_source_project",  // 問い合わせ発行元プロジェクト
            NOTICE_TARGET_PROJECT: "notice_target_project",   // お知らせ発行先プロジェクト
            NOTICE_TARGET_USER: "notice_target_user",      // お知らせ発行先ユーザー
            EMAIL_ORIGIN: "email_origin",           // 発行元
            ACTIVE_ARCHIVED_STATUS: "active_archived_status",  // Active/Archived
            FIELD_QA_CATEGORY: "field_qa_category",    // 問い合わせカテゴリー
            
            // Field chỉ có ở knowledge drilldown
            POST_TARGET_PROJECT: "post_target_project",     // 投稿先プロジェクト
            FIELD_CHATGPT_MODEL_AI_AUTO: "field_chatgpt_model_ai_auto", // ChatGPTモデル
            APPLY_AI_PROMPT: "ApplyAIprompt",           // AI-プロンプト適用
            AIPROMPTAPPLICATIONTARGET: "AIPromptApplicationTarget", // AI-プロンプト適用先
            AI_BASIC_INFO_TRANSMISSION: "AIBasicInfoTransmission", // AI-基本情報の送信
            AI_PDF_PAGE_SPLIT_STATUS: "ai_pdf_page_split_status", // 添付PDFが完全にページ分割されたこと
            FIELD_TICKET_TYPE_ACTIVE_AI_AUTO: "field_ticket_type_active_ai_auto", // AI-コンテンツ種類
            FIELD_FORM_ACTIVE_AI_AUTO: "field_form_active_ai_auto", // AI-コンテンツフォーマット
            FIELD_EVENT_TRIGGER_AI_AUTO: "field_event_trigger_ai_auto", // AI-イベント種類
            FIELD_HOURS_EXECUTE_AI_AUTO: "field_hours_execute_ai_auto", // AI-プロンプト実行時刻(時) 
            FIELD_MINUTES_EXECUTE_AI_AUTO: "field_minutes_execute_ai_auto", // AI-プロンプト実行時刻(分)
            FIELD_EVENT_TYPE_CHAT_THREAD: "field_event_type_chat_thread", // AI-イベント種類-チャットスレッド
            SDAUTO_AS_TOOL_CALL: "sdauto_as_tool_call",     // AIからの呼び出し
            SDAUTO_CALL_SCRIPT_API_SETTING: "sdauto_call_script_api_setting", // API呼び出し
            SDAUTO_CALL_SCRIPT_API_SETTING_TARGET: 'sdauto_call_script_api_setting_target', // API呼び出し対象
            SDAUTO_RE_CAPTCHA: "sdauto_re_captcha",       // reCAPTCHAによる検証を有効にする
    },

    AI_AUTO: {
        SYSTEM_FIELD: {
            TICKET_TYPE_ACTIVE:"field_ticket_type_active_ai_auto",
            FORM_ACTIVE:"field_form_active_ai_auto",
            EVENT_TRIGGER: "field_event_trigger_ai_auto",
            CHAT_THREAD_TYPE_TRIGGER: "field_event_type_chat_thread",
            HOURS_EXECUTE:"field_hours_execute_ai_auto",
            MINUTES_EXECUTE:"field_minutes_execute_ai_auto",
            AND: "field_tag_and_ai_auto",
            OR: "field_tag_or_ai_auto",
            EXCLUDE: "field_tag_exclude_ai_auto",
            TIME_EXECUTE: 'field_time_execute_ai_auto',
            CHATGPT_MODEL: "field_chatgpt_model_ai_auto",
            MCP_SERVER_SETTING: "field_mcp_server_setting",
            REASONING_EFFORT: "field_reasoning_effort_ai_auto",
            EVENT_TRIGGER_CREATE: 'field_event_trigger_ai_prompt_tag_with_create_action',
            EVENT_TRIGGER_UPDATE: 'field_event_trigger_ai_prompt_tag_with_change_content_action',
            EVENT_TRIGGER_CHAT_OUTSIDE: 'field_event_trigger_ai_prompt_tag_with_new_customer_escalate_chat_action',
            EVENT_TRIGGER_CHAT_IN_PROJECT: 'field_event_trigger_ai_prompt_tag_with_new_internal_chat_action',
            EVENT_TRIGGER_CALL_COMPLETED: 'field_event_trigger_ai_prompt_tag_with_call_completed_action',
            AI_BASIC_INFO_TRANSMISSION: 'AIBasicInfoTransmission',
            AI_PDF_PAGE_SPLIT_STATUS: 'ai_pdf_page_split_status'
        },
        TICKET_TYPE_TAG_OPTIONS: {
            QA:"field_ticket_type_active_ai_prompt_tag_qa_form",
            NOTICE: "field_ticket_type_active_ai_prompt_tag_notice_form",
            TASK: "field_ticket_type_active_ai_prompt_tag_task_form",
            EMAIL: "field_ticket_type_active_ai_prompt_tag_email_form",
            KNOWLEDGE: "field_ticket_type_active_ai_prompt_tag_knowledge_form",
            TELEPHONE: "field_ticket_type_active_ai_prompt_tag_telephone_form"
        },
        FILE_EXTENSIONS: [
            {
              id: "doc",
              name: "doc"
            },
            {
              id: "docx",
              name: "docx"
            },
            {
              id: "pdf",
              name: "pdf"
            },
            {
              id: "txt",
              name: "txt"
            },
            {
              id: "rtf",
              name: "rtf"
            },
            {
              id: "xls",
              name: "xls"
            },
            {
              id: "xlsx",
              name: "xlsx"
            },
            {
              id: "ppt",
              name: "ppt"
            },
            {
              id: "pptx",
              name: "pptx"
            },
            {
              id: "jpg",
              name: "jpg"
            },
            {
              id: "jpeg",
              name: "jpeg"
            },
            {
              id: "png",
              name: "png"
            },
            {
              id: "gif",
              name: "gif"
            },
            {
              id: "bmp",
              name: "bmp"
            },
            {
              id: "svg",
              name: "svg"
            },
            {
              id: "webp",
              name: "webp"
            },
            {
              id: "mp3",
              name: "mp3"
            },
            {
              id: "wav",
              name: "wav"
            },
            {
              id: "aac",
              name: "aac"
            },
            {
              id: "flac",
              name: "flac"
            },
            {
              id: "ogg",
              name: "ogg"
            },
            {
              id: "mp4",
              name: "mp4"
            },
            {
              id: "mkv",
              name: "mkv"
            },
            {
              id: "avi",
              name: "avi"
            },
            {
              id: "mov",
              name: "mov"
            },
            {
              id: "wmv",
              name: "wmv"
            },
            {
              id: "webm",
              name: "webm"
            },
            {
              id: "zip",
              name: "zip"
            },
            {
              id: "rar",
              name: "rar"
            },
            {
              id: "7z",
              name: "7z"
            },
            {
              id: "tar",
              name: "tar"
            },
            {
              id: "gz",
              name: "gz"
            },
            {
              id: "html",
              name: "html"
            },
            {
              id: "htm",
              name: "htm"
            },
            {
              id: "css",
              name: "css"
            },
            {
              id: "js",
              name: "js"
            },
            {
              id: "py",
              name: "py"
            },
            {
              id: "java",
              name: "java"
            },
            {
              id: "c",
              name: "c"
            },
            {
              id: "cpp",
              name: "cpp"
            },
            {
              id: "php",
              name: "php"
            },
            {
              id: "exe",
              name: "exe"
            },
            {
              id: "bat",
              name: "bat"
            },
            {
              id: "sh",
              name: "sh"
            },
            {
              id: "dll",
              name: "dll"
            },
            {
              id: "sys",
              name: "sys"
            },
            {
              id: "psd",
              name: "psd"
            },
            {
              id: "ai",
              name: "ai"
            },
            {
              id: "xd",
              name: "xd"
            },
            {
              id: "sketch",
              name: "sketch"
            },
            {
              id: "dwg",
              name: "dwg"
            },
            {
              id: "iso",
              name: "iso"
            },
            {
              id: "torrent",
              name: "torrent"
            },
            {
              id: "md",
              name: "md"
            },
            {
              id: "log",
              name: "log"
            }
        ],
        SPECIAL_LABEL_TAG_OPTIONS: {
            QA_TICKET_PROJECT: "問い合わせ発行元プロジェクト",
            NOTICE_TICKET_PROJECT: "お知らせ発行先プロジェクト",
            EMAIL_FORM_FIELD_PROJECT: "発行元",
            STATUS: "ステータス",
            FILE_EXTENSION:"添付データ種類",
            TELEPHONE_CALL_STATUS: "通話ステータス",
            TELEPHONE_CALL_HANDLER: '応対者'
        },
        SENDER_MAIL: [
            {
                id: "customer",
                name:"カスタマー"
            },
            {
                id: "project",
                name:"プロジェクト"
            }
        ],

        FIELD_TIME_EXE: 'field_time_execute_ai_auto',

        CHAT_THREAD_TYPE_OPTION: {
            THREAD_CUSTOMER: "field_event_type_chat_thread_customer",
            THREAD_IN_PROJECT: "field_event_type_chat_thread_in_project",
            THREAD_ESCALATION: "field_event_type_chat_thread_escalation"
        }

    },

    SD_AUTO: {
        SYSTEM_FIELD: {
            PURPOSE: 'sdauto_purpose',
            LANGUAGE: 'sdauto_language',
            DESCRIPTION: 'sdauto_description',
            GENERATED_PROMPT: 'sdauto_generated_prompt',
            SCRIPT_FLOW: 'sdauto_script_flow',
            SCRIPT: 'sdauto_script',
            SDAUTO_PARAMS_DESCRIPTION: 'sdauto_params_description',
            SDAUTO_AS_TOOL_CALL:'sdauto_as_tool_call',
            SDAUTO_AS_TOOL_CALL_OFF: 'sdauto_as_tool_call_off',
            SDAUTO_AS_TOOL_CALL_ON: 'sdauto_as_tool_call_on',
            
            // SD auto call script api setting fields
            SDAUTO_CALL_SCRIPT_API_SETTING: 'sdauto_call_script_api_setting',
            SDAUTO_CALL_SCRIPT_API_SETTING_OFF: 'sdauto_call_script_api_setting_off',
            SDAUTO_CALL_SCRIPT_API_SETTING_ON: 'sdauto_call_script_api_setting_on',
            
            // SD auto call script api setting target fields
            SDAUTO_CALL_SCRIPT_API_SETTING_TARGET: 'sdauto_call_script_api_setting_target',
            SDAUTO_CALL_SCRIPT_API_SETTING_TARGET_IN_PRJ: 'sdauto_call_script_api_setting_target_in_prj',
            SDAUTO_CALL_SCRIPT_API_SETTING_TARGET_IN_ORG: 'sdauto_call_script_api_setting_target_in_org',
            SDAUTO_CALL_SCRIPT_API_SETTING_TARGET_B2B_CUSTOMER: 'sdauto_call_script_api_setting_target_b2b_customer',
            SDAUTO_CALL_SCRIPT_API_SETTING_TARGET_B2B_SUPPORT: 'sdauto_call_script_api_setting_target_b2b_support',
            SDAUTO_CALL_SCRIPT_API_SETTING_TARGET_B2C_IN_PRJ: 'sdauto_call_script_api_setting_target_b2c_in_prj',
            SDAUTO_CALL_SCRIPT_API_SETTING_TARGET_B2C_IN_ORG: 'sdauto_call_script_api_setting_target_b2c_in_org',
            SDAUTO_CALL_SCRIPT_API_SETTING_TARGET_PUBLIC: 'sdauto_call_script_api_setting_target_public',
            
            SDAUTO_RE_CAPTCHA: 'sdauto_re_captcha',
            SDAUTO_RE_CAPTCHA_ON: 'sdauto_re_captcha_on',
            SDAUTO_RE_CAPTCHA_OFF: 'sdauto_re_captcha_off',
        }
    },

    DRILLDOWN_TAG_ITEM_TYPE: {
        TAG_FIELD: 'tag_field',
        MASTER_TAG_FIELD: 'master_tag_field',
        FORM: 'form',
        PROJECT: 'project',
        USER: 'user',
        KNOWLEDGE: 'knowledge',
    },

    AI_AUTO_LOG: {
        GET_LIST_PAGINATION: 'GET_LIST_PAGINATION',
        RETRY_GET_LIST_LOG: 'RETRY_GET_LIST_LOG',
        GET_LIST_OPERATOR_PROMPT_LOG: 'GET_LIST_OPERATOR_PROMPT_LOG'
    },

    AI_AUTO_UPDATE_TYPE: {
        PLAY: 'PLAY',
        PAUSE: 'PAUSE',
        DELETE: 'DELETE'
    },

    CHATTHREAD_TYPE: {
        AI_AUTO: 'AI_AUTO',
        DEFAULT: 'DEFAULT',
        SD_AUTO: 'SD_AUTO',
        OPERATOR_PROMPT: 'OPERATOR_PROMPT',
        AI_TRAINING: 'AI_TRAINING'
    },

    CHATTHREAD_STATUS: {
        RUNNING: 'RUNNING',
        STOP: 'STOP',
        DONE: 'DONE',
        ERROR: 'ERROR'
    },

    CORPORATION_ATOM_DEFAULT_DATA : {
        corporationName: '',
        corporationLogo: '/assets/image/accela-technology.png',
        isLoadDataWithAPI: false,
        corporationSetting:{}
    },

    CHECK_VIEW_TICKET_PERMISSION_METHOD: {
        VIEW_TICKET_HTML_FIELD: 'VIEW_TICKET_HTML_FIELD',
        CHECK_PERMISSION_OPEN_TAB_CHAT_AI: 'CHECK_PERMISSION_OPEN_TAB_CHAT_AI',
        VIEW_TICKET_SDSCRIPT_FIELD: 'VIEW_TICKET_SDSCRIPT_FIELD',
        VIEW_TICKET_HTML_APP: 'VIEW_TICKET_HTML_APP',
        VIEW_TRANSCRIPT_LOG: 'VIEW_TRANSCRIPT_LOG',
        VIEW_TRANSCRIPT_AUDIO: 'VIEW_TRANSCRIPT_AUDIO',
    },
    
    EMAIL_SEND_BY_OPTION: {
        CUSTOMER_OUT_DESK: "CUSTOMER_OUT_DESK",
        CUSTOMER_IN_DESK: "CUSTOMER_IN_DESK",
        DESK: "DESK"
    },

    SEND_AND_CHANGE_STATUS_TYPE: {
        PENDING: 'PENDINGで送信',
        DOING: 'DOINGで送信',
        DONE: 'DONEで送信',
        TODO: 'TODOで送信'
    },

    INPUT_TYPE: {
        PASSWORD: 'password',
        TEXT: 'text'
    },

    SYSTEM_FIELD_NAME : {
        PERSON_IN_CHARGE: '担当者',
        PERSON_IN_CHARGE_EMAIL: '担当者メールアドレス',
        STATUS: 'ステータス',
        TICKET_ID: 'コンテンツID',
        PRIVATE_BOOKMARK_TAG: 'private_bookmarktag',
        PRIVATE_BOOKMARK_TAG_ADD: 'private_bookmarktag_add',
        PRIVATE_BOOKMARK_TAG_REMOVE: 'private_bookmarktag_remove',
        SHARED_BOOKMARK_TAG: 'shared_bookmarktag',
        SHARED_BOOKMARK_TAG_ADD: 'shared_bookmarktag_add',
        SHARED_BOOKMARK_TAG_REMOVE: 'shared_bookmarktag_remove',
        AI_PDF_PAGE_SPLIT_STATUS: '添付PDFが完全にページ分割されたこと',
        CHAT_THREAD_TYPE_TRIGGER: 'AI-イベント種類-チャットスレッド',
        MCP_SERVER_SETTING: '外部連携設定',
    },

    ID_PREFIX: {
        TAG: 'tag',
        FIELD: 'field',
        FORM: 'form',
        KNOWLEDGE: 'knowledge',
        PROJECT: 'project',
        ORGANIZATION: 'corp',
        USER: 'user',
        EXTERNAL_API: 'externalApi',
        MCP_SERVER: 'mcpServer',
        SHARE_TICKET_IMAGE: 'att',
        SHARE_CHAT_IMAGE: 'msg_att',
        REASONING_CHATPOST_PREFIX: 'rs_',
        OPENAI_CONNECTOR_PERSONAL: 'personal_connector_',
        CHAT_POST: 'post',
        STATUS: 'status',
        AI_TELEPHONE_FIELD_ID_PREFIX: 'ai_telephone_',
        TELEPHONE_STATUS_PREFIX: 'telephone_call_status_',
        CHATGPT_MODEL_TAG_PREFIX: 'field_chatgpt_model_ai_auto_tag_'
    },

    NOTICE_METHOD: {
        SINGLE: 0,
        MULTIPLE: 1
    },

    NOTICE_RECIPIENT_OPTIONS: {
        ALL_CUSTOMER_PROJECTS:  'カスタマープロジェクト',
        ALL_GUEST_CUSTOMER_USERS:  'ゲストカスタマーユーザー',
        ALL_GENERAL_PROJECTS:  '組織内プロジェクト',
        ALL_BASE_USER_PROJECTS: '組織内ユーザー'
    },


    QUERY_METHOD: {
        GET_TAG_ITEMS_BY_TAG_FIELD_IDS: 'GET_TAG_ITEMS_BY_TAG_FIELD_IDS',
        BATCH: 'BATCH',
        GET_TAG_ITEMS_BY_FIELD_ID: 'GET_TAG_ITEMS_BY_FIELD_ID',
        SEARCH_TAG_ITEMS_BY_FIELD_ID_AND_KEYWORD: 'SEARCH_TAG_ITEMS_BY_FIELD_ID_AND_KEYWORD'
    },
    
    ITERATOR: 'iterator',

    OPTION_UNASSIGNEE: {
        KEY: 'option_unassignee',
        TEXT: ''
    },

    OPTION_ASSIGNEE_ME: '<<私>>',


    END_SDAUTO_LOG: 'end <sdauto> log',
    SD_AUTO_COMMAND: '<sdauto>',

    DISPLAY_MODE: {
        VIEW: 'VIEW',
        EDIT: 'EDIT'
    },

    CHAT_GPT_MODEL_STATUS: {
        SUPPORT: 'support',
        UNSUPPORT: 'unsupport'
    },

    NO_PREFERENCE: 'No Preference',
    NO_REFERENCE: 'No reference',

    ORG_ACTION: {
        BLOCK: 'BLOCK',
        UNLOCK: 'UNLOCK',
    },
    
    // EXTERNAL_API
    EXTERNAL_API_AUTHEN_STATUS: {
        SUCCESS: 'SUCCESS',
        UNAUTHORIZED: 'UNAUTHORIZED',
        FAIL: 'FAIL'
    },

    AUTH_METHOD_EXTERNAL_API: {
        OAUTH2: 'OAUTH2',
        JWT: 'JWT',
        BASE: 'BASE',
        NONE: 'NONE',
        OAUTH2_SETTING: 'oauth2Setting',
        JWT_SETTING: 'jwtSetting',
        BASE_SETTING: 'baseSetting',
        NONE_SETTING: 'none'
    },

    EXTERNAL_API_OWNER_BY: {
        ORG: 'ORG',
        PROJECT: 'PROJECT',
        USER: 'USER',
        NA: 'NA'
    },

    EXTERNAL_API_OUT_FORMAT: {
        JSON: 'JSON',
        HTML: 'HTML',
        TEXT: 'TEXT',
        XML: 'XML',
    },

    ACCESS_DENIED: 'access_denied',

    EXTERNAL_API_GET_METHOD: {
        GET_LIST_PAGINATION: 'GET_LIST_PAGINATION'
    },

    EXTERNAL_API_GET_LIST_LIMIT: 20,

    EXTERNAL_API_UPDATE_ACTION_TYPE: {
        CREATE_NEW: 'CREATE_NEW',
        UPDATE_BY_ID: 'UPDATE_BY_ID',
        DELETE_BY_ID: 'DELETE_BY_ID',
        RUN_AUTH: 'RUN_AUTH',
        RUN_TEST: 'RUN_TEST',
        AUTHEN_BY_OAUTH2: 'AUTHEN_BY_OAUTH2',
        AUTHEN_BY_JWT: 'AUTHEN_BY_JWT',
        AUTHEN_BY_BASE: 'AUTHEN_BY_BASE'
    },

    SETTING_VERSION_LABEL: {
        EXTERNAL_WEB_API: 'externalWebAPI',

        NUMBER_OF_EX_WEB_API: 'numberOfExWebAPI',
        NUMBER_OF_QA_COUNTERS: 'numberOfQACounters',
        NUMBER_OF_SUPPORTED_COUNTERS: 'numberOfSupportedCounters',
        NUMBER_OF_B2C: 'numberOfB2C',
        NUMBER_OF_KNOWLEDGES: 'numberOfKnowledges',

        NUMBER_OF_ADDITIONAL_EX_WEB_API: 'numberOfAdditionalExWebAPI',
        NUMBER_OF_ADDITIONAL_KNOWLEDGE: 'numberOfAdditionalKnowledge',
        NUMBER_OF_ADDITIONAL_QA_COUNTER: 'numberOfAdditionalQACounter',
        NUMBER_OF_ADDITIONAL_SUPPORTED_COUNTER: 'numberOfAdditionalSupportedCounter',

        MCP_SERVER: 'mcpServer',
        TELEPHONE_AGENT: 'telephoneAgent',
    },

    PREFIX_EXTERNAL_API: 'externalApi_',

    SYSTEM_FIELD: {
        GUEST_ORG: 'guestOrg',
        GUEST_PROJECT: 'guestProject',
        ADMIN_MAIL_ADRESS: 'adminMailAdress',
        ADMIN_LAST_NAME: 'adminLastName',
        ADMIN_FIRST_NAME: 'adminFirstName',
        OUTLINE: 'outline',
        CATEGORY: 'category',
        DESCRIPTION: 'description',
        ATTACHMENTS: 'attachments',
        PERSON_IN_CHARGE: 'personInCharge',
        FROM: 'from',
        TO: 'to',
        CC: 'cc',
        BCC: 'bcc',
        MAIL_SUBJECT: 'mailSubject',
        MAIL_BODY: 'mailBody',
        TICKET_ID: 'ticketId',
        TICKET_TYPE: 'ticketType',
        PROXIED_USER: 'proxiedUser',
        DEADLINE: 'deadline',
        LIST_OF_SYNONYMS: 'listOfSynonyms',
        BODY: 'body',
        FIELD_QA_CATEGORY: 'field_qa_category',
        SDAUTO_SCRIPT: 'sdauto_script',
        SDAUTO_PARAMS_DESCRIPTION: 'sdauto_params_description',
        CUSTOMER_EMAIL: 'customerEmail',
        CUSTOMER_LAST_NAME: 'customerLastName',
        CUSTOMER_FIRST_NAME: 'customerFirstName',
        FOOTPRINT: 'footPrint',
        PARENT: 'parent',
        CHILDREN: 'children',
        ESCALATION_ORIGIN_CUSTOMER: 'escalationOriginCustomer',
        ESCALATION_TARGET: 'escalationTarget',
        PRIORITY: 'priority',
        BOOKMARK: 'bookmark',
        POINT: 'point',
        AI_PROMPT_BODY: 'AIPromptBody',
        APPLY_AI_PROMPT: 'ApplyAIprompt',
        AI_PROMPT_APPLICATION_TARGET: 'AIPromptApplicationTarget',
        AI_BASIC_INFO_TRANSMISSION: 'AIBasicInfoTransmission',
        PAGE_NO: 'pageNo',
        CHAPTER: 'chapter',
        SECTION: 'section',
        SUBSECTION: 'subSection',
        ITEM: 'item',
        TICKET_TYPE_ACTIVE:"field_ticket_type_active_ai_auto",
        FORM_ACTIVE: 'field_form_active_ai_auto',
        AND: 'field_tag_and_ai_auto',
        OR: "field_tag_or_ai_auto",
        EXCLUDE: "field_tag_exclude_ai_auto",
        EVENT_TRIGGER: "field_event_trigger_ai_auto",
        CHAT_THREAD_TYPE_TRIGGER: "field_event_type_chat_thread",
        TIME_EXECUTE: 'field_time_execute_ai_auto',
        HOURS_EXECUTE:"field_hours_execute_ai_auto",
        MINUTES_EXECUTE:"field_minutes_execute_ai_auto",
        CHATGPT_MODEL: "field_chatgpt_model_ai_auto",
        MCP_SERVER_SETTING: "field_mcp_server_setting",
        REASONING_EFFORT: "field_reasoning_effort_ai_auto",
        SDAUTO_PURPOSE: 'sdauto_purpose',
        SDAUTO_LANGUAGE: 'sdauto_language',
        SDAUTO_DESCRIPTION: 'sdauto_description',
        SDAUTO_GENERATED_PROMPT: 'sdauto_generated_prompt',
        SDAUTO_SCRIPT_FLOW: 'sdauto_script_flow',
        AI_ASSISTANT_MERMAID: 'sdauto_script_flow',
        SDAUTO_AS_TOOL_CALL:'sdauto_as_tool_call',
        SDAUTO_CALL_SCRIPT_API_SETTING: 'sdauto_call_script_api_setting',
        SDAUTO_CALL_SCRIPT_API_SETTING_TARGET: 'sdauto_call_script_api_setting_target',
        SDAUTO_RE_CAPTCHA: 'sdauto_re_captcha',
        AI_PDF_PAGE_SPLIT_STATUS: 'ai_pdf_page_split_status',
        AI_PDF_PAGE_SPLIT_STATUS_TRUE: 'ai_pdf_page_split_status_true',
        AI_PDF_PAGE_SPLIT_STATUS_FALSE: 'ai_pdf_page_split_status_false',
        MODEL_CHAT_GPT_5: 'field_chatgpt_model_ai_auto_tag_5',
        MODEL_CHAT_GPT_5_2: 'field_chatgpt_model_ai_auto_tag_52',
        MODEL_CHAT_GPT_5_4: 'field_chatgpt_model_ai_auto_tag_54',
        MODEL_CHAT_GPT_5_4_MINI: 'field_chatgpt_model_ai_auto_tag_54_mini',
        MODEL_CHAT_GPT_5_5: 'field_chatgpt_model_ai_auto_tag_55',
        BUSINESS_APP_NAME: 'field_business_app_name',
        BUSINESS_APP_NAME_PAGE: 'field_business_app_page',
        BUSINESS_APP_USE_RANGE: 'field_business_app_use_range',
        BUSINESS_APP_DISPLAY_SIDE_BAR: 'field_business_app_display_side_bar',
        BUSINESS_APP_DISPLAY_SIDE_ON: 'field_business_app_display_side_on',
        BUSINESS_APP_DISPLAY_SIDE_OFF: 'field_business_app_display_side_off',
        AI_TELEPHONE_OPERATOR_NAME: 'ai_telephone_operator_name',
        AI_TELEPHONE_REFERENCE_KNOWLEDGE: 'ai_telephone_reference_knowledge',
        AI_TELEPHONE_TRIGGER_CONDITION: 'ai_telephone_trigger_condition',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_MODE: 'ai_telephone_receiving_call_execution_mode',
        AI_TELEPHONE_TIME_BASED_DELAY_RESPONSE: 'ai_telephone_time_based_delay_response',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_TIME_PERIOD: 'ai_telephone_receiving_call_execution_time_period',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_TIME: 'ai_telephone_receiving_call_execution_start_time',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_TIME: 'ai_telephone_receiving_call_execution_end_time',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_DATE: 'ai_telephone_receiving_call_execution_start_date',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_DATE: 'ai_telephone_receiving_call_execution_end_date',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_DAY_OF_WEEKS: 'ai_telephone_receiving_call_execution_day_of_weeks',
        AI_TELEPHONE_APPLICABLE_PHONE_NUMBER: 'ai_telephone_applicable_phone_number',
        AI_TELEPHONE_EXECUTION_SCOPE: 'ai_telephone_execution_scope',
        AI_TELEPHONE_VOICE_SETTINGS: 'ai_telephone_voice_settings',
        AI_TELEPHONE_REALTIME_MODEL: 'ai_telephone_realtime_model',
        AI_TELEPHONE_TRIGGER_CONDITION_RECEIVING: 'ai_telephone_trigger_condition_receiving',
        AI_TELEPHONE_TRIGGER_CONDITION_MAKING: 'ai_telephone_trigger_condition_making',
        AI_TELEPHONE_EXECUTION_SCOPE_EXTERNAL: 'ai_telephone_execution_scope_external',
        AI_TELEPHONE_EXECUTION_SCOPE_INTERNAL: 'ai_telephone_execution_scope_internal',
        AI_TELEPHONE_TRIGGER_CONDITION_TRAINING: 'ai_telephone_trigger_condition_training',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_MODE_ANSWERING_MACHINE: 'ai_telephone_receiving_call_execution_mode_answering_machine',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_TIME_PERIOD_ITEM: 'ai_telephone_receiving_call_execution_time_period_item',
    },

    LIMIT_TAB_CHAT_AI: 100,
    MFA: {
        PREFERENCE_TYPE: {
            TOTP: 'TOTP',
            NOMFA: 'NOMFA'
        },
        CHALLENGE_NAME: {
            SOFTWARE_TOKEN_MFA: 'SOFTWARE_TOKEN_MFA',
            NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED'
        },
        ERROR_CODE:{
            CODE_EXPIRED:'EnableSoftwareTokenMFAException',
            CODE_INVALID_FORMAT:'InvalidParameterException',
        }
    },
    
    MODEL_PROMPT_TYPE: {
        SYSTEM_PROMPT: 'systemPrompt',
        INTERATOR_SYSTEM_PROMPT: 'interatorSystemPrompt',
    },

    UPDATE_VIEW_RESOURCE_METHOD: {
        CREATE_VIEW: 'CREATE_VIEW',
        UPDATE_VIEW: 'UPDATE_VIEW',
        DELETE_VIEW: 'DELETE_VIEW',
        UPDATE_ORDER_VIEW_KNOWLEDGE: 'UPDATE_ORDER_VIEW_KNOWLEDGE',
        CREATE_VIEW_WITH_VISIBLE_TYPE: 'CREATE_VIEW_WITH_VISIBLE_TYPE',
        UPDATE_PUBLIC_RANGE_VIEW: 'UPDATE_PUBLIC_RANGE_VIEW',
        SHOW_VIEW: 'SHOW_VIEW'
    },

    SYNC_TRIGGER_SOURCE: {
        PROJECT: 'PROJECT',
        IN_ORG: 'IN_ORG'
    },

    UPDATE_ORDER_VIEW_TYPE: {
        SORT_DATA: 'SORT_DATA', // Update sortData per user (PROJECT visibility)
        ORDER: 'ORDER'          // Batch update order field (other visibility)
    },

    DOWNLOAD_UPLOAD_METHOD: {
        DOWNLOAD: 'DOWNLOAD',
        UPLOAD: 'UPLOAD'
    },
    
    TASK_TYPE: {
        COMMAND_UPLOAD_CSV: 'COMMAND_UPLOAD_CSV',
        SETTING_SEND_MAIL_ERROR: 'SETTING_SEND_MAIL_ERROR',
        BULK_ACTION_PARENT_TASK: 'BULK_ACTION_PARENT_TASK',
        BULK_ACTION_CHILD_TASK: 'BULK_ACTION_CHILD_TASK',
        BULK_UPLOAD_TAG: 'BULK_UPLOAD_TAG'
    },
    TASK_USAGE: {
        COMMAND: 1,
        SETTING: 2,
        UPLOAD_CSV: 3,
        UPLOAD_CSV_CRAWL: 4,
        BULK_UPDATE_TICKET: 5,
        BULK_UPDATE_TICKET_CHILDREN: 6,
        BULK_UPLOAD_TAG: 7
    },

    LIMIT_FILES_UPLOAD: 10,

    MCP_SERVER_TYPE: {
        MCP_SERVER: 'MCP_SERVER',
        OPENAI_CONNECTOR: 'OPENAI_CONNECTOR',
        OPENAI_CONNECTOR_PERSONAL: 'OPENAI_CONNECTOR_PERSONAL'
    },

    ATTACH_FILES_LIMIT: 4,

    ATTACH_FILE_TYPE: {
        CHAT: 'chat',
        TICKET: 'ticket',
        AI_CHAT: 'ai_chat',
    },

    // MCP_SERVER_SETTING
    MCP_SERVER_CONNECT_STATUS: {
        SUCCESS: 'SUCCESS',
        NOT_CONNECT: 'NOT_CONNECT',
        FAIL: 'FAIL'
    },

    AUTH_METHOD_MCP_SERVER: {
        OAUTH2: 'OAUTH2',
        JWT: 'JWT',
        BASE: 'BASE',
        NONE: 'NONE',
        BEARER: 'BEARER',
        APIKEY: 'APIKEY',
        
        OAUTH2_SETTING: 'oauth2Setting',
        JWT_SETTING: 'jwtSetting',
        BASE_SETTING: 'baseSetting',
        NONE_SETTING: 'none',
        BEARER_SETTING: 'bearerSetting',
        APIKEY_SETTING: 'apiKeySetting',
    },

    MCP_SERVER_OWNER_BY: {
        ORG: 'ORG',
        PROJECT: 'PROJECT',
        USER: 'USER',
        NA: 'NA'
    },

    MCP_SERVER_UPDATE_ACTION_TYPE: {
        CREATE_NEW: 'CREATE_NEW',
        UPDATE_BY_ID: 'UPDATE_BY_ID',
        DELETE_BY_ID: 'DELETE_BY_ID',
        TOGGLE_ACTIVE_IN_ORG: 'TOGGLE_ACTIVE_IN_ORG',
        TOGGLE_ACTIVE_IN_PROJECT: 'TOGGLE_ACTIVE_IN_PROJECT',
        RUN_AUTH: 'RUN_AUTH',
        RUN_TEST: 'RUN_TEST',
        AUTHEN_BY_OAUTH2: 'AUTHEN_BY_OAUTH2',
        AUTHEN_BY_JWT: 'AUTHEN_BY_JWT',
        AUTHEN_BY_BASE: 'AUTHEN_BY_BASE',
        AUTHEN_BY_APIKEY: 'AUTHEN_BY_APIKEY',
        AUTHEN_BY_BEARER: 'AUTHEN_BY_BEARER',
        AUTHEN_BY_NONE: 'AUTHEN_BY_NONE',
        AUTHEN_BY_PERSONAL_CONNECTOR: 'AUTHEN_BY_PERSONAL_CONNECTOR',
        DISCONNECT_PERSONAL_CONNECTOR: 'DISCONNECT_PERSONAL_CONNECTOR'
    },

    MCP_SERVER_GET_METHOD: {
        GET_LIST_PAGINATION: 'GET_LIST_PAGINATION',
        GET_LIST_ACTIVE_MCP_BY_PROJECT: 'GET_LIST_ACTIVE_MCP_BY_PROJECT',
        GET_MCP_SERVER_BY_ID: 'GET_MCP_SERVER_BY_ID',
        GET_MCP_SERVER_BY_ID_NO_VALIDATE: 'GET_MCP_SERVER_BY_ID_NO_VALIDATE',
        GET_MCP_SERVER_BY_ID_LIST: 'GET_MCP_SERVER_BY_ID_LIST',
        GET_MCP_SERVER_BY_OWNER_BY: 'GET_MCP_SERVER_BY_OWNER_BY'
    },

    MCP_SERVER_GET_LIST_LIMIT: 1000,

    PREFIX_MCP_SERVER: 'mcpServer_',

    MCP_SERVER_ACTIVE_DATA: {
        ON: 'true',
        OFF: 'false'
    },

    MCP_SERVER_TEXT: {
        SERVER_NAME: 'serverName',
        SERVER_URL: 'serverURL',
        AUTH_METHOD: 'authMethod',
        OPENAI_CONNECTOR: 'openaiConnectorId',
        API_KEY: 'apiKey',
        BEARER: 'bearer',
        IS_ACTIVE_CORP: 'isActiveCorp',
        MEMO: 'memo'
    },
    ORDER_IN_LIST_FIELD_KEY : 'orderInList',
    ORDER_DEFAULT_LIST_FIELD : 1000,

    SORT_DEFAULT_SYSTEM_FIELD : [
        // Group 1: Drilldown only (Order: 0-99) 
        // Field common có cả ở ticket drilldown và knowledge drilldown
        'system_tags_form',        // フォーマット名
        'creator',                 // 投稿ユーザー
        'updator',                 // 更新ユーザー
        'suffixOfAttachments',     // 添付データ種類
        'privateBookmark',         // 個人用ブックマークタグ
        'sharedBookmark',          // 共有ブックマークタグ
        
        // Field chỉ có ở ticket drilldown
        'ticket_type_category',              // チケット種類
        'inquiry_source_project',  // 問い合わせ発行元プロジェクト
        'notice_target_project',   // お知らせ発行先プロジェクト
        'notice_target_user',      // お知らせ発行先ユーザー
        'email_origin',           // 発行元
        'active_archived_status',  // Active/Archived
        'field_qa_category',    // 問い合わせカテゴリー
        'telephone_call_status', // 電話状態
        'telephone_call_type', // 電話タイプ
        'telephone_call_mode', // 電話モード
        'telephone_from', // 電話発信者
        'telephone_to', // 電話受信者
        'telephone_call_handler', // 電話担当者
        'telephone_caller_language', // 電話発信者言語
        'telephone_receiver_language', // 電話受信者言語
        'telephone_follow_up_status', // フォローアップステータス
        'telephone_review_status', // 評価ステータス
        'telephone_evaluator', // 評価担当
        
        // Field chỉ có ở knowledge drilldown
        'post_target_project',     // 投稿先プロジェクト
        'field_chatgpt_model_ai_auto', // ChatGPTモデル
        'field_reasoning_effort_ai_auto', // 推論レベル
        'ApplyAIprompt',           // AI-プロンプト適用
        'AIPromptApplicationTarget', // AI-プロンプト適用先
        'AIBasicInfoTransmission', // AI-基本情報の送信
        'ai_pdf_page_split_status', // 添付PDFが完全にページ分割されたこと
        'field_ticket_type_active_ai_auto', // AI-コンテンツ種類
        'field_form_active_ai_auto', // AI-コンテンツフォーマット
        'field_event_trigger_ai_auto', // AI-イベント種類
        'field_hours_execute_ai_auto', // AI-プロンプト実行時刻(時)
        'field_minutes_execute_ai_auto', // AI-プロンプト実行時刻(分)
        'field_event_type_chat_thread', // AI-イベント種類-チャットスレッド
        'sdauto_as_tool_call',     // AIからの呼び出し
        'sdauto_call_script_api_setting', // API呼び出し
        'sdauto_call_script_api_setting_target', // API呼び出し対象
        'sdauto_re_captcha',       // reCAPTCHAによる検証を有効にする
        'field_business_app_display_side_bar', // ビジネスアプリ表示サイドバー
        'field_business_app_use_range',        // 利用可能範囲
        'field_mcp_server_setting',            // 外部連携設定
        
        // Group 2: List only (Order: 100-199)
        'attachments',             // 添付ファイル
        'parent',                  // 親コンテンツ
        'escalationOriginCustomer', // エスカレーション元のカスタマー
        'escalationTarget',        // エスカレーション先
        'outline',                 // 概要
        'listOfSynonyms',          // 類義語一覧
        
        // Group 3: Both list & drilldown (Order: 200-299)
        'proxiedUser',             // 代理投稿者
        'personInCharge',          // 担当者
        'field_status',             // ステータス

    ],


    SHOW_FIELD_IN_DRILLDOWN: {
        SHOW: 1,
        HIDE: 0
    },
    
    STREAM_STATUS: {
        STOP: 'STOP'
    },

    FILTER_FIELD_OPTION: {
        ALL: 'all'
    },

    BUSINESS_APP_ALLOW_FILE_EXTENSIONS:  [
        '.jpeg',
        '.jpg',
        '.jpe',
        '.jfif',
        '.jfi',
        '.jif',
        '.bmp',
        '.gif',
        '.png'
    ],

    UPLOAD_FILE_ERROR_CODE: {
        FILE_TOO_LARGE: 'file-too-large',
        FILE_INVALID_TYPE: 'file-invalid-type',
        TOO_MANY_FILES: 'too-many-files',
    },
    UNNAMED_MCP_SERVER: 'Unnamed Server',

    PERSONAL_CONNECTOR_SERVICE_NAME: {
        DROPBOX: 'Dropbox',
        GMAIL: 'Gmail',
        GOOGLE_CALENDAR: 'Google Calendar',
        GOOGLE_DRIVE: 'Google Drive',
        MICROSOFT_TEAM: 'Microsoft Teams',
        OUTLOOK_GMAIL: 'Outlook Gmail',
        OUTLOOK_CALENDAR: 'Outlook Calendar',
        SHAREPOINT: 'SharePoint'
    },

    PERSONAL_CONNECTOR_COMMON_ID: {
        DROPBOX: 'personal_connector_dropbox',
        GMAIL: 'personal_connector_gmail',
        GOOGLE_CALENDAR: 'personal_connector_google_calendar',
        GOOGLE_DRIVE: 'personal_connector_google_drive',
        MICROSOFT_TEAM: 'personal_connector_microsoft_team',
        OUTLOOK_GMAIL: 'personal_connector_outlook_gmail',
        OUTLOOK_CALENDAR: 'personal_connector_outlook_calendar',
        SHAREPOINT: 'personal_connector_sharepoint'
    },

    PERSONAL_CONNECTOR_OAUTH2_URL: {
        DROPBOX: 'https://www.dropbox.com/oauth2/authorize',
        GOOGLE: 'https://accounts.google.com/o/oauth2/auth',
        MICROSOFT: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize'
    },

    PERSONAL_CONNECTOR_OAUTH2_SCOPE: {
        DROPBOX: [
            { label: 'files.metadata.read', value: 'files.metadata.read' },
            { label: 'files.content.read', value: 'files.content.read' },
            { label: 'files.metadata.write', value: 'files.metadata.write' },
            { label: 'files.content.write', value: 'files.content.write' },
            { label: 'account_info.read', value: 'account_info.read' },
            // Below are additional scopes to ensure listing files and folders works in all cases
            { label: 'list files and folders', value: 'files.metadata.read' } // Note: files.metadata.read covers list
        ],
        GMAIL: [
            { label: 'userinfo.email', value: 'https://www.googleapis.com/auth/userinfo.email' },
            { label: 'userinfo.profile', value: 'https://www.googleapis.com/auth/userinfo.profile' },
            { label: 'gmail.modify', value: 'https://www.googleapis.com/auth/gmail.modify' }
        ],
        GOOGLE_CALENDAR: [
            { label: 'userinfo.email', value: 'https://www.googleapis.com/auth/userinfo.email' },
            { label: 'userinfo.profile', value: 'https://www.googleapis.com/auth/userinfo.profile' },
            { label: 'calendar.events', value: 'https://www.googleapis.com/auth/calendar.events' }
        ],
        GOOGLE_DRIVE: [
            { label: 'userinfo.email', value: 'https://www.googleapis.com/auth/userinfo.email' },
            { label: 'userinfo.profile', value: 'https://www.googleapis.com/auth/userinfo.profile' },
            { label: 'drive.readonly', value: 'https://www.googleapis.com/auth/drive.readonly' }
        ],
        MICROSOFT_TEAM: [
            { label: 'Chat.Read', value: 'https://graph.microsoft.com/Chat.Read' },
            { label: 'ChannelMessage.Read.All', value: 'https://graph.microsoft.com/ChannelMessage.Read.All' },
            { label: 'User.Read', value: 'https://graph.microsoft.com/User.Read' },
            { label: 'offline_access', value: 'offline_access' }
        ],
        OUTLOOK_GMAIL: [
            { label: 'Mail.Read', value: 'https://graph.microsoft.com/Mail.Read' },
            { label: 'User.Read', value: 'https://graph.microsoft.com/User.Read' },
            { label: 'offline_access', value: 'offline_access' }
        ],
        OUTLOOK_CALENDAR: [
            { label: 'Calendars.Read', value: 'https://graph.microsoft.com/Calendars.Read' },
            { label: 'User.Read', value: 'https://graph.microsoft.com/User.Read' },
            { label: 'offline_access', value: 'offline_access' }
        ],
        SHAREPOINT: [
            { label: 'Sites.Read.All', value: 'https://graph.microsoft.com/Sites.Read.All' },
            { label: 'Files.Read.All', value: 'https://graph.microsoft.com/Files.Read.All' },
            { label: 'User.Read', value: 'https://graph.microsoft.com/User.Read' },
            { label: 'offline_access', value: 'offline_access' }
        ]
    },

    CONSTANT_SYSTEM_CHAT_AI_MESSAGE_TYPE: {
        ERROR_NOT_CONNECTED_CONNECTOR: 'ERROR_NOT_CONNECTED_CONNECTOR'
    },

    DEFAULT_CONNECTOR_VALUE: {
        SCOPE: 'https://www.googleapis.com/auth/userinfo.email,https://www.googleapis.com/auth/userinfo.profile,https://www.googleapis.com/auth/calendar.events',
        OPENAI_CONNECTOR_ID: 'connector_googlecalendar',
    },
    SORT_BY: {
        ASC: 'asc',
    },
    
    PHONE_AVAILABILITY: {
        IDLE: 'IDLE',               // Not initialized or disconnected
        READY: 'READY',             // Device ready to make/receive calls
        CONNECTING: 'CONNECTING',   // Call is connecting
        ACTIVE: 'ACTIVE',           // Call is active/in progress
        DISCONNECTED: 'DISCONNECTED'// Call ended/disconnected
    },

    TELEPHONE_SETTINGS: {
        MAX_RECENT_CALLS: 10,
        DEFAULT_RECENT_CALLS_LIMIT: 3,
        CALL_TYPE: {
            USER: 'user',
            PROJECT: 'project',
            EXTERNAL: 'external'
        },
        CALL_STATUS: {
            INITIATED: 'initiated',
            CONNECTING: 'connecting',
            CONNECTED: 'connected',
            COMPLETED: 'completed',
            NO_ANSWER: 'no-answer',
            BUSY: 'busy',
            FAILED: 'failed'
        }
    },
    NO_ORDER_VALUE: Number.MAX_SAFE_INTEGER,

    AI_TELEPHONE_PROMPT_SYSTEM_FIELD: {
        OPERATOR_NAME: 'ai_telephone_operator_name',
        REALTIME_MODEL: 'ai_telephone_realtime_model',
        REFERENCE_KNOWLEDGE: 'ai_telephone_reference_knowledge',
        TRIGGER_CONDITION: 'ai_telephone_trigger_condition',
        RECEIVING_CALL_EXECUTION_MODE: 'ai_telephone_receiving_call_execution_mode',
        TIME_BASED_DELAY_RESPONSE: 'ai_telephone_time_based_delay_response',
        RECEIVING_CALL_EXECUTION_TIME_PERIOD: 'ai_telephone_receiving_call_execution_time_period',
        RECEIVING_CALL_EXECUTION_START_TIME: 'ai_telephone_receiving_call_execution_start_time',
        RECEIVING_CALL_EXECUTION_END_TIME: 'ai_telephone_receiving_call_execution_end_time',
        RECEIVING_CALL_EXECUTION_START_DATE: 'ai_telephone_receiving_call_execution_start_date',
        RECEIVING_CALL_EXECUTION_END_DATE: 'ai_telephone_receiving_call_execution_end_date',
        RECEIVING_CALL_EXECUTION_DAY_OF_WEEKS: 'ai_telephone_receiving_call_execution_day_of_weeks',
        APPLICABLE_PHONE_NUMBER: 'ai_telephone_applicable_phone_number',
        EXECUTION_SCOPE: 'ai_telephone_execution_scope',
        VOICE_SETTINGS: 'ai_telephone_voice_settings',
    },

    AI_TELEPHONE_PROMPT_SYSTEM_FIELD_DISPLAY_IN_FIELD_LIST: [
        'ai_telephone_realtime_model',
        'ai_telephone_trigger_condition',
        'ai_telephone_receiving_call_execution_mode',
        'ai_telephone_execution_scope',
        'ai_telephone_voice_settings'
    ],

    AI_TRAINING_PROMPT_SYSTEM_FIELD: {
        OPERATOR_NAME: 'ai_telephone_operator_name',
        REALTIME_MODEL: 'ai_telephone_realtime_model',
        REFERENCE_KNOWLEDGE: 'ai_telephone_reference_knowledge',
        VOICE_SETTINGS: 'ai_telephone_voice_settings',
    },

    AI_TRAINING_PROMPT_SYSTEM_FIELD_DISPLAY_IN_FIELD_LIST: [
        'ai_telephone_realtime_model',
        'ai_telephone_voice_settings',
    ],

    AI_TELEPHONE_DATA_PROMPT_TYPE: {
        AUTO_RESPONSE: 'ai_telephone_prompt_type_auto_response',
        TRAINING: 'ai_telephone_prompt_type_training',
        ASSISTANT: 'ai_telephone_prompt_type_assistant',
        CALL_EVALUATION: 'ai_telephone_prompt_type_call_evaluation',
    },

    AI_ASSISTANT_PROMPT_SYSTEM_FIELD: {
        OVERVIEW: 'outline',                                            // Shared field
        OPERATOR_NAME: 'ai_telephone_operator_name',                    // Reuse từ AI Telephone
        AI_MODEL: 'field_chatgpt_model_ai_auto',                        // Shared field
        REASONING_MODE: 'field_reasoning_effort_ai_auto',               // Shared field
        DESCRIPTION: 'sdauto_description',                              // Shared field
        AI_PROMPT: 'AIPromptBody',                                      // Shared field
        MERMAID: 'sdauto_script_flow',                                  // Reuse từ SD Auto
        APPLICATION: 'ApplyAIprompt',                                   // Shared field
        REFERENCE_KNOWLEDGE: 'ai_telephone_reference_knowledge',        // Reuse từ AI Telephone
        EXTERNAL_INTEGRATION: 'field_mcp_server_setting',               // Shared field
        TRIGGER_CONDITION: 'ai_telephone_trigger_condition',            // Reuse từ AI Telephone
        EXECUTION_SCOPE: 'ai_telephone_execution_scope',                // Reuse từ AI Telephone
        APPLICABLE_PHONE_NUMBER: 'ai_telephone_applicable_phone_number', // Reuse từ AI Telephone
    },

    AI_ASSISTANT_PROMPT_SYSTEM_FIELD_DISPLAY_IN_FIELD_LIST: [
        'ai_telephone_trigger_condition',
        'ai_telephone_execution_scope',
    ],
    
    HAMBURGER_MENU_OPTION: {
        PERMANENT_DELETE: 'permanentDelete',
        DELETE: 'delete',
        ARCHIVE: 'archive',
        KNOWLEDGE: 'knowledge',
        CHAT: 'chat',
        KNOWLEDGE_LIST: 'knowledgeList',
    },

    FIELD_VALID_INTEGER: {
        MAX_VALUE: '{{maxValue}}',
        MIN_VALUE: '{{minValue}}',
    },
    DEFAULT_COUNTRY_CODE: '+81',

    MODEL_NAME_PLACEHOLDER: '{{model_name}}',

    // AI Error Patterns - Regex patterns for detecting specific AI error messages
    AI_ERROR_PATTERNS: {
        UNSUPPORTED_MODEL: /ChatGPTモデル「.*」は利用できません/
    },

    PANEL_STATUS_KEY: {
        TICKET: 'ticketStatus',
        TELEPHONE_WORKFLOW: 'telephoneWorkflowStatus'
    },

    ANSWER: '**回答:**',
    ASSISTANT: 'assistant',
};

export default Constant;
